/* Formula Scents — theme behaviour (v3)
   Header overlay + glass, scroll progress, reveals, scroll hero, cart helper,
   pack builder, scent finder, video reel, drop countdown, quick add. */
(function () {
  'use strict';

  var FS = window.FS = window.FS || {};
  var root = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Money ---------- */
  FS.money = function (cents) {
    var fmt = FS.moneyFormat || '${{amount}}';
    cents = Math.round(Number(cents) || 0);
    function withDelims(n, precision, thousands, decimal) {
      var parts = (n / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(precision ? decimal : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(cents, 2, "'", '.');
        default: return withDelims(cents, 2, ',', '.');
      }
    });
  };

  /* ---------- Cart ---------- */
  FS.addToCart = function (items) {
    var url = (FS.routes && FS.routes.cartAdd) || '/cart/add.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data && (data.description || data.message) || 'Could not add to cart');
        return data;
      });
    }).then(function (data) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('fs:cart:added', { detail: data }));
      return data;
    });
  };

  FS.openCart = function () {
    // UpCart (app drawer) — refresh and open if its API is present.
    try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
    var opened = false;
    ['upcartOpenCart', 'openUpcart'].forEach(function (fn) {
      if (!opened && typeof window[fn] === 'function') { try { window[fn](); opened = true; } catch (e) {} }
    });
    if (opened) return;
    // Otherwise hand off to whatever drawer the cart icon opens; it falls back to the cart page.
    setTimeout(function () {
      var icon = document.querySelector('#cart-icon-bubble, a.header__icon--cart, a[href$="/cart"]');
      if (icon) icon.click(); else window.location.href = (FS.routes && FS.routes.cart) || '/cart';
    }, 250);
  };

  /* ---------- Header overlay, glass on scroll, progress ---------- */
  function measureHeader() {
    var group = document.querySelectorAll('.shopify-section-group-header-group');
    var total = 0, sticky = 0;
    group.forEach(function (s) {
      var h = s.offsetHeight; total += h;
      if (s.querySelector('.header-wrapper, fs-header')) sticky = h;
    });
    root.style.setProperty('--fs-header-h', total + 'px');
    root.style.setProperty('--fs-header-sticky', (sticky || total) + 'px');
  }
  function initOverlay() {
    var main = document.getElementById('MainContent');
    var first = main && main.firstElementChild;
    if (FS.overlay && first && first.querySelector('[data-fs-overlay]')) root.classList.add('fs-overlay');
    measureHeader();
  }
  var progress = document.querySelector('.fs-progress');
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var y = window.scrollY || window.pageYOffset;
      root.classList.toggle('fs-scrolled', y > 24);
      if (progress) {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        progress.style.setProperty('--fs-scroll', max > 0 ? Math.min(1, y / max).toFixed(4) : 0);
      }
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { measureHeader(); onScroll(); }, { passive: true });
  window.addEventListener('load', measureHeader);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureHeader);

  /* ---------- Reveal on scroll ---------- */
  function initReveal(scope) {
    var items = (scope || document).querySelectorAll('.fs-reveal:not(.is-in)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
  }

  function define(name, cls) { if (!customElements.get(name)) customElements.define(name, cls); }

  /* ---------- Scroll-scrubbed hero ---------- */
  define('fs-scroll-hero', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.frameLabel = this.querySelector('[data-fs-frame]');
      this.mode = this.dataset.mode || 'scrub';
      this.target = 0; this.current = 0; this.ready = false;
      this._onScroll = this.onScroll.bind(this);
      this._tick = this.tick.bind(this);
      if (!this.video) this.mode = 'static';
      if (this.mode === 'scrub' && (reduceMotion || this.dataset.designMode === 'true')) this.mode = 'loop';
      if (this.mode === 'loop') { this.startLoop(); return; }
      if (this.mode === 'static') return;
      // Don't start pulling the hero video until the logo loader has finished, so the
      // download and decode don't steal frames from the loader animation.
      var self = this;
      if (document.documentElement.classList.contains('fs-loading')) {
        document.addEventListener('fs:loader:done', function () { self.loadForScrub(); }, { once: true });
      } else this.loadForScrub();
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });
      this.onScroll();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
      if (this.raf) cancelAnimationFrame(this.raf);
      if (this.blobUrl) URL.revokeObjectURL(this.blobUrl);
    }
    pickSource() {
      var small = window.matchMedia('(max-width: 749px)').matches;
      return (small && this.dataset.srcMobile) || this.dataset.src || '';
    }
    loadForScrub() {
      var v = this.video, src = this.pickSource(), self = this;
      v.muted = true; v.playsInline = true; v.pause();
      v.addEventListener('loadedmetadata', function () { self.ready = true; self.duration = v.duration || 0; self.onScroll(); }, { once: true });
      if (!src) { v.load(); return; }
      fetch(src).then(function (r) { if (!r.ok) throw new Error('fetch'); return r.blob(); })
        .then(function (blob) { self.blobUrl = URL.createObjectURL(blob); v.src = self.blobUrl; v.load(); })
        .catch(function () { v.src = src; v.load(); });
      var unlock = function () {
        var p = v.play(); if (p && p.then) p.then(function () { v.pause(); }).catch(function () {});
      };
      window.addEventListener('touchstart', unlock, { passive: true, once: true });
    }
    startLoop() {
      var v = this.video; if (!v) return;
      var src = this.pickSource();
      if (src && !v.getAttribute('src')) v.src = src;
      v.muted = true; v.loop = true; v.playsInline = true;
      if (!reduceMotion) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }
    onScroll() {
      var rect = this.getBoundingClientRect();
      var travel = rect.height - window.innerHeight;
      this.target = travel > 0 ? Math.min(1, Math.max(0, -rect.top / travel)) : 0;
      if (!this.raf) this.raf = requestAnimationFrame(this._tick);
    }
    tick() {
      this.raf = null;
      this.current += (this.target - this.current) * 0.18;
      if (Math.abs(this.target - this.current) < 0.0005) this.current = this.target;
      this.style.setProperty('--fs-p', this.current.toFixed(4));
      this.classList.toggle('is-moving', this.current > 0.02);
      if (this.ready && this.duration) {
        var t = this.current * (this.duration - 0.05);
        if (Math.abs(this.video.currentTime - t) > 0.01) { try { this.video.currentTime = t; } catch (e) {} }
        if (this.frameLabel) {
          var total = parseInt(this.dataset.frames || '120', 10);
          var f = Math.round(this.current * (total - 1)) + 1;
          this.frameLabel.textContent = ('00' + f).slice(-3) + ' / ' + ('00' + total).slice(-3);
        }
      }
      if (this.current !== this.target) this.raf = requestAnimationFrame(this._tick);
    }
  });

  /* ---------- Racing header + slide-out menu ---------- */
  define('fs-header', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.section = this.closest('.shopify-section') || this;
      root.classList.add('fs-has-racing-header');
      this.drawer = document.getElementById(this.dataset.drawer);
      this.burger = this.querySelector('[data-fs-drawer-open]');
      if (this.drawer && this.drawer.parentElement !== document.body) {
        // Fixed drawer must not live inside the sticky/transformed header.
        if (this.portal) this.portal.remove();
        this.portal = this.drawer;
        document.body.appendChild(this.drawer);
      }
      this._onKey = function (e) {
        if (!self.isOpen) return;
        if (e.key === 'Escape') { e.preventDefault(); self.close(); return; }
        if (e.key === 'Tab') self.trap(e);
      };
      this._onClick = function (e) {
        if (e.target.closest('[data-fs-drawer-close]')) { self.close(); return; }
        var sub = e.target.closest('[data-fs-sub]');
        if (sub) {
          var open = sub.getAttribute('aria-expanded') !== 'true';
          sub.setAttribute('aria-expanded', String(open));
          var list = document.getElementById(sub.getAttribute('aria-controls'));
          if (list) list.hidden = !open;
          return;
        }
        if (e.target.closest('a[href]')) self.close(true);
      };
      if (this.burger) this.burger.addEventListener('click', function () { self.isOpen ? self.close() : self.open(); });
      if (this.drawer) this.drawer.addEventListener('click', this._onClick);
      document.addEventListener('keydown', this._onKey);
      // hide on scroll down / show on scroll up
      this.lastY = window.scrollY;
      this._onScroll = function () {
        if (self.dataset.hideOnScroll !== 'true' || self.isOpen) return;
        var y = window.scrollY, dy = y - self.lastY;
        if (Math.abs(dy) < 6) return;
        var hide = dy > 0 && y > self.section.offsetHeight + 120;
        self.section.classList.toggle('fs-hdr-hidden', hide);
        self.lastY = y;
      };
      window.addEventListener('scroll', this._onScroll, { passive: true });
    }
    disconnectedCallback() {
      document.removeEventListener('keydown', this._onKey);
      window.removeEventListener('scroll', this._onScroll);
      if (this.portal && !document.contains(this)) this.portal.remove();
    }
    open() {
      if (!this.drawer) return;
      var d = this.drawer;
      this.isOpen = true;
      this.lastFocus = document.activeElement;
      this.section.classList.remove('fs-hdr-hidden');
      d.hidden = false;
      root.classList.add('fs-drawer-open');
      if (this.burger) this.burger.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('is-open'); }); });
      var first = d.querySelector('.fs-drawer__close');
      setTimeout(function () { if (first) first.focus(); }, 60);
    }
    close(viaLink) {
      if (!this.drawer || !this.isOpen) return;
      var d = this.drawer, self = this;
      this.isOpen = false;
      d.classList.remove('is-open');
      root.classList.remove('fs-drawer-open');
      if (this.burger) this.burger.setAttribute('aria-expanded', 'false');
      setTimeout(function () { if (!self.isOpen) d.hidden = true; }, reduceMotion ? 0 : 560);
      if (!viaLink && this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    }
    trap(e) {
      var f = Array.prototype.filter.call(this.drawer.querySelectorAll('a[href], button:not([disabled]), select, input'), function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Quick add (product rail) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fs-quick-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    var label = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = btn.dataset.loading || 'Adding…';
    FS.addToCart([{ id: Number(btn.dataset.fsQuickAdd), quantity: 1 }])
      .then(function () { btn.textContent = btn.dataset.added || 'Added'; FS.openCart(); })
      .catch(function (err) { btn.textContent = err.message.slice(0, 40); })
      .finally(function () { setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 1800); });
  });

  /* ---------- Pack builder ---------- */
  define('fs-pack', class extends HTMLElement {
    connectedCallback() {
      var dataEl = this.querySelector('script[data-fs-pack-data]');
      if (!dataEl) return;
      try { this.cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var self = this;
      this.byV = {};
      this.cfg.products.forEach(function (p) { self.byV[p.v] = p; p.sc = scentKey(p.t); });
      // refill add-on: the matching refill for diffusers / vent clips in the pack (not sprays). Full price, one-time.
      this.refillBy = {}; this.refillByV = {}; this.refills = [];
      (this.cfg.refill || []).forEach(function (r) { r.sc = scentKey(r.t); self.refillBy[r.sc] = r; self.refillByV[r.v] = r; });
      this.refillEl = this.querySelector('[data-fs-refill]');
      this.size = this.cfg.size;
      this.picks = [];
      this.storeKey = 'fsPack:' + (this.id || 'pack');
      this.gridEl = this.querySelector('[data-fs-grid]');
      this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-fs-scent]'));
      this.cardByV = {};
      this.cards.forEach(function (c) { self.cardByV[c.dataset.fsScent] = c; });
      this.slotsEl = this.querySelector('[data-fs-slots]');
      this.cta = this.querySelectorAll('[data-fs-pack-add]');
      this.msg = this.querySelector('[data-fs-pack-msg]');
      this.moreBtn = this.querySelector('[data-fs-more]');
      this.tiers = this.cfg.tiers || {};
      this.kinds = [];
      ['h', 's', 'v'].forEach(function (k) { if (self.cfg.products.some(function (p) { return p.k === k; })) self.kinds.push(k); });
      this.tab = this.kinds[0] || 'h';
      this.open = {};
      this.order();

      // Subscription plans, per format. Each format (hanging / spray / vent clip) lists its own Seal plans
      // with their delivery interval; a format with several plans gets a picker. No plan = one-time.
      this.plansK = {}; this.planK = {}; this.oK = {};
      this.cfg.products.forEach(function (p) {
        (p.sp || []).forEach(function (a) {
          var L = self.plansK[p.k] = self.plansK[p.k] || [];
          if (L.indexOf(a.n) < 0) L.push(a.n);
          if (a.o && !self.oK[a.n]) self.oK[a.n] = a.o;
        });
      });
      Object.keys(this.plansK).forEach(function (k) { self.planK[k] = self.plansK[k][0]; });
      this.subOn = false;
      this.subWrap = this.querySelector('[data-fs-sub]');
      this.subToggle = this.querySelector('[data-fs-sub-toggle]');
      this.subPlans = this.querySelector('[data-fs-sub-plans]');
      this.subEnabled = !!(this.cfg.sub && Object.keys(this.plansK).length && this.subWrap);
      if (this.subEnabled) {
        this.subWrap.hidden = false;
        this.subOn = !!this.cfg.subDefault;
        this.addEventListener('change', function (e) {
          var sel = e.target.closest && e.target.closest('[data-fs-plan-kind]');
          if (sel) { self.planK[sel.dataset.fsPlanKind] = sel.value; self.render(); }
        });
      }

      this.restore();
      this.readUrl();
      this.addEventListener('click', this.onClick.bind(this));
      this._onExternal = function (e) {
        var vs = (e.detail && e.detail.variants) || [];
        if (e.detail && e.detail.size) self.setSize(e.detail.size, true);
        vs.forEach(function (v) { self.add(Number(v), true); });
        var first = self.byV[Number(vs[0])]; if (first) self.tab = first.k;
        self.render();
        self.say(self.picks.length ? (self.cfg.t.loaded || 'Loaded into your pack.') : '', 'ok');
      };
      window.addEventListener('fs:pack:add', this._onExternal);
      this._mq = window.matchMedia('(min-width: 990px)');
      this._onMq = function () { self.render(); };
      if (this._mq.addEventListener) this._mq.addEventListener('change', this._onMq);
      this.render();
    }
    disconnectedCallback() {
      window.removeEventListener('fs:pack:add', this._onExternal);
      if (this._mq && this._mq.removeEventListener) this._mq.removeEventListener('change', this._onMq);
    }
    // Hanging keeps the collection's order (best selling). Spray and vent cards follow the same
    // scent order, sold-out cards go last, and they borrow the diffuser's "Inspired by" line.
    order() {
      var self = this, rank = {}, subBy = {}, i = 0;
      this.cfg.products.forEach(function (p) { if (p.k === 'h' && rank[p.sc] == null) { rank[p.sc] = i++; subBy[p.sc] = p.sub; } });
      var list = this.cards.map(function (c, idx) {
        var p = self.byV[c.dataset.fsScent];
        if (p && !p.sub && subBy[p.sc]) {
          p.sub = subBy[p.sc];
          var sl = c.querySelector('[data-fs-sub-line]'); if (sl) sl.textContent = p.sub;
        }
        var r = p && p.k === 'h' ? idx : (p && rank[p.sc] != null ? rank[p.sc] : 999 + idx);
        return { c: c, k: p ? p.k : 'h', r: r, a: p && p.a ? 0 : 1, idx: idx };
      });
      list.sort(function (a, b) { return (a.k === b.k ? 0 : (a.k < b.k ? -1 : 1)) || a.a - b.a || a.r - b.r || a.idx - b.idx; });
      // sold-out limited-drop cards: pulled up to a visible spot (default 4th) instead of sitting last
      var pos = Math.max(1, this.cfg.dropPos || 4) - 1;
      ['h', 's', 'v'].forEach(function (k) {
        var inK = list.filter(function (x) { return x.k === k; });
        var drops = inK.filter(function (x) { var p = self.byV[x.c.dataset.fsScent]; return p && p.d && !p.a; });
        if (!drops.length) return;
        var rest = inK.filter(function (x) { return drops.indexOf(x) < 0; });
        Array.prototype.splice.apply(rest, [Math.min(pos, rest.length), 0].concat(drops));
        var start = list.indexOf(inK[0]);
        Array.prototype.splice.apply(list, [start, inK.length].concat(rest));
      });
      if (this.gridEl) list.forEach(function (x) { self.gridEl.appendChild(x.c); });
      this.cards = list.map(function (x) { return x.c; });
    }
    save() { try { sessionStorage.setItem(this.storeKey, JSON.stringify({ s: this.size, p: this.picks, r: this.refills, sub: this.subOn, planK: this.planK, tab: this.tab })); } catch (e) {} }
    restore() {
      try {
        var raw = sessionStorage.getItem(this.storeKey); if (!raw) return;
        var st = JSON.parse(raw), self = this;
        if (this.cfg.sizes.indexOf(st.s) > -1) this.size = st.s;
        if (this.subEnabled && typeof st.sub === 'boolean') this.subOn = st.sub;
        if (st.planK) Object.keys(st.planK).forEach(function (k) { if ((self.plansK[k] || []).indexOf(st.planK[k]) > -1) self.planK[k] = st.planK[k]; });
        if (st.tab && this.kinds.indexOf(st.tab) > -1) this.tab = st.tab;
        (st.p || []).forEach(function (v) { if (self.byV[v] && self.byV[v].a && self.picks.length < self.size) self.picks.push(v); });
        (st.r || []).forEach(function (v) { if (self.refillByV[v] && self.refills.indexOf(v) < 0) self.refills.push(v); });
      } catch (e) {}
    }
    readUrl() {
      var m = window.location.search.match(/[?&]pack=([\d,]+)/);
      if (!m) return;
      var self = this;
      this.picks = [];
      m[1].split(',').forEach(function (v) { self.add(Number(v), true); });
    }
    say(text, kind) {
      if (!this.msg) return;
      this.msg.textContent = text || '';
      this.msg.className = 'fs-pack__msg' + (kind ? ' is-' + kind : '');
    }
    emit(type, extra) {
      var n = this.picks.length, d = { type: type, n: n, size: this.size, pct: this.tierPct(this.size), full: n === this.size };
      if (extra) Object.keys(extra).forEach(function (k) { d[k] = extra[k]; });
      try { window.dispatchEvent(new CustomEvent('fs:pack:change', { detail: d })); } catch (e) {}
    }
    count(v) { return this.picks.filter(function (x) { return x === v; }).length; }
    tierPct(n) {
      var best = 0, t = this.tiers;
      Object.keys(t).forEach(function (q) { if (Number(q) <= n && t[q] > best) best = t[q]; });
      return best;
    }
    // the plan an item ships on while subscribed: the picked plan if it has it, else its own; null = one-time
    alloc(p) {
      if (!this.subOn || !p || !p.sp || !p.sp.length) return null;
      var want = this.planK[p.k];
      for (var i = 0; i < p.sp.length; i++) if (p.sp[i].n === want) return p.sp[i];
      return p.sp[0];
    }
    unit(p) { var a = this.alloc(p); return a ? a.p : p.p; }
    oneTime(p) { return this.subOn && !!p && !this.alloc(p); }
    tagFor(p) { return p && p.a && this.oneTime(p) ? (this.cfg.t.oneTime || 'One-time') : ''; }
    add(v, silent) {
      var p = this.byV[v];
      if (!p || !p.a) return false;
      if (!this.cfg.dup && this.count(v) > 0) { if (!silent) this.say(this.cfg.t.noDup, 'error'); return false; }
      if (this.picks.length >= this.size) {
        var bigger = this.cfg.sizes.filter(function (s) { return s > this.size; }, this)[0];
        if (!silent) this.say(bigger ? this.cfg.t.fullBigger.replace('[size]', bigger) : this.cfg.t.full, 'error');
        return false;
      }
      this.picks.push(v);
      return true;
    }
    remove(v) { var i = this.picks.lastIndexOf(v); if (i > -1) this.picks.splice(i, 1); }
    setSize(s, silent) {
      s = Number(s);
      if (this.cfg.sizes.indexOf(s) < 0) return;
      this.size = s;
      if (this.picks.length > s) { this.picks = this.picks.slice(0, s); if (!silent) this.say(this.cfg.t.trimmed, ''); }
    }
    pool() {
      var tab = this.tab, self = this;
      return this.cfg.products.filter(function (p) { return p.a && p.k === tab && (self.cfg.dup || self.count(p.v) === 0); });
    }
    onClick(e) {
      var t = e.target.closest('button'); if (!t || !this.contains(t)) return;
      if (t.dataset.fsNotify) {
        var np = this.byV[Number(t.dataset.fsNotifyV)];
        FS.notifyOpen(t.dataset.fsNotify, (np && np.vs && np.vs.length) ? np.vs : [Number(t.dataset.fsNotifyV)]);
        this.emit('notify', { name: t.dataset.fsNotify }); return;
      }
      var ev = null;
      if (t.dataset.fsAdd) {
        var v = Number(t.dataset.fsAdd), was = this.picks.length;
        if (this.add(v)) { this.say(''); ev = ['add', { el: this.cardByV[v] || null, oneTime: this.oneTime(this.byV[v]), kind: this.byV[v].k, was: was }]; }
      }
      else if (t.dataset.fsMinus) { this.remove(Number(t.dataset.fsMinus)); this.say(''); }
      else if (t.dataset.fsSlotRemove !== undefined) { this.picks.splice(Number(t.dataset.fsSlotRemove), 1); this.say(''); }
      else if (t.dataset.fsSize) { var before = this.size; this.setSize(t.dataset.fsSize); if (this.size > before) ev = ['size', {}]; }
      else if (t.dataset.fsTab) { this.tab = t.dataset.fsTab; ev = ['tab', { kind: this.tab }]; }
      else if (t.hasAttribute('data-fs-more')) { this.open[this.tab] = !this.open[this.tab]; }
      else if (t.hasAttribute('data-fs-random')) { this.random(); ev = ['random', {}]; }
      else if (t.hasAttribute('data-fs-sub-toggle')) { if (t.getAttribute('aria-disabled') === 'true') return; this.subOn = !this.subOn; this.say(''); }
      else if (t.hasAttribute('data-fs-clear')) { this.picks = []; this.refills = []; this.say(''); }
      else if (t.dataset.fsRefillToggle) {
        var rv = Number(t.dataset.fsRefillToggle), ri = this.refills.indexOf(rv);
        if (ri > -1) this.refills.splice(ri, 1); else if (this.refillByV[rv]) this.refills.push(rv);
        ev = ['refill', { on: ri < 0, name: (this.refillByV[rv] || {}).t || '' }];
      }
      else if (t.hasAttribute('data-fs-dock-view')) { var pn = this.querySelector('.fs-pack__panel'); if (pn) pn.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      else if (t.hasAttribute('data-fs-pack-add')) { this.submit(); return; }
      else return;
      this.render();
      if (ev) this.emit(ev[0], ev[1]);
    }
    random() {
      var pool = this.pool(), me = this;
      if (!pool.length) pool = this.cfg.products.filter(function (p) { return p.a; });
      var guard = 0;
      while (this.picks.length < this.size && pool.length && guard++ < 200) {
        var p = pool[Math.floor(Math.random() * pool.length)];
        if (this.add(p.v, true) && !this.cfg.dup) pool = pool.filter(function (x) { return x.v !== p.v; });
      }
      this.say(this.cfg.t.randomized, 'ok');
    }
    render() {
      var self = this, size = this.size, n = this.picks.length, tab = this.tab;
      this.querySelectorAll('[data-fs-size]').forEach(function (b) { b.setAttribute('aria-pressed', String(Number(b.dataset.fsSize) === size)); });
      // tabs + how many of each format are in the pack
      var perKind = { h: 0, s: 0, v: 0 };
      this.picks.forEach(function (v) { var p = self.byV[v]; if (p) perKind[p.k]++; });
      this.querySelectorAll('[data-fs-tab]').forEach(function (b) { b.setAttribute('aria-selected', String(b.dataset.fsTab === tab)); });
      this.querySelectorAll('[data-fs-tab-n]').forEach(function (el) { var c = perKind[el.dataset.fsTabN] || 0; el.textContent = c; el.hidden = !c; });
      // cards — this tab only, first N unless opened; each at the price it costs in this pack
      var limit = this.cfg.show ? this.cfg.show[this._mq && this._mq.matches ? 1 : 0] : 999;
      var inTab = 0, cardPct = this.tierPct(size);
      this.cards.forEach(function (card) {
        var v = Number(card.dataset.fsScent), p = self.byV[v], c = self.count(v);
        var mine = !!p && p.k === tab;
        if (mine) inTab++;
        card.hidden = !mine || (!self.open[tab] && inTab > limit && c === 0);
        card.classList.toggle('is-picked', c > 0);
        var cnt = card.querySelector('[data-fs-count]'); if (cnt) cnt.textContent = '×' + c;
        var tagEl = card.querySelector('[data-fs-tag]');
        if (tagEl && p) { var tg = self.tagFor(p); tagEl.textContent = tg; tagEl.hidden = !tg; tagEl.classList.toggle('is-onetime', self.oneTime(p)); }
        var add = card.querySelector('[data-fs-add]');
        if (add && p && p.a) {
          var blocked = n >= size || (!self.cfg.dup && c > 0);
          add.classList.toggle('is-disabled', blocked);
          add.setAttribute('aria-disabled', String(blocked));
          add.textContent = c > 0 ? (self.cfg.dup ? self.cfg.t.addAnother : self.cfg.t.inPack) : self.cfg.t.add;
        }
        var priceEl = card.querySelector('[data-fs-price]');
        if (priceEl && p) {
          var now = Math.round(self.unit(p) * (100 - cardPct) / 100);
          priceEl.innerHTML = now < p.p ? '<s>' + FS.money(p.p) + '</s> <b>' + FS.money(now) + '</b>' : FS.money(p.p);
        }
      });
      if (this.moreBtn) {
        this.moreBtn.hidden = inTab <= limit;
        this.moreBtn.textContent = this.open[tab] ? this.cfg.t.less : this.cfg.t.more.replace('[n]', inTab);
      }
      // slots
      var cols = size <= 3 ? size : (size === 4 ? 4 : 3);
      this.slotsEl.style.setProperty('--fs-slots-cols', cols);
      var html = '', pips = '';
      for (var i = 0; i < size; i++) {
        var p = this.byV[this.picks[i]];
        if (p) {
          var kl = p.k === 's' ? this.cfg.t.kindS : (p.k === 'v' ? this.cfg.t.kindV : ''), ot = this.oneTime(p);
          html += '<div class="fs-slot is-filled"><span class="fs-slot__pos">P' + (i + 1) + '</span>' +
            (p.img ? '<img src="' + p.img + '" alt="" loading="lazy" width="200" height="200">' : '') +
            '<span class="fs-slot__name">' + escapeHtml(p.t) + '</span>' +
            (kl || ot ? '<span class="fs-slot__kind' + (ot ? ' is-onetime' : '') + '">' + escapeHtml(ot ? (this.cfg.t.oneTime || 'One-time') : kl) + '</span>' : '') +
            '<button type="button" class="fs-slot__remove" data-fs-slot-remove="' + i + '" aria-label="' + escapeHtml(self.cfg.t.remove + ' ' + p.t) + '">' +
            '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>';
          pips += '<i class="is-on"></i>';
        } else {
          html += '<div class="fs-slot"><span class="fs-slot__pos">P' + (i + 1) + '</span><span class="fs-slot__empty">+</span></div>';
          pips += '<i></i>';
        }
      }
      this.slotsEl.innerHTML = html;
      this.querySelectorAll('[data-fs-pips]').forEach(function (el) { el.innerHTML = pips; });
      // refill add-on offers: scents in the pack that come as a refill (diffusers + vent clips), newest first
      var offer = [];
      for (var j = this.picks.length - 1; j >= 0; j--) {
        var pj = this.byV[this.picks[j]];
        if (pj && pj.k !== 's' && this.refillBy[pj.sc] && offer.indexOf(pj.sc) < 0) offer.push(pj.sc);
      }
      this.refills = this.refills.filter(function (v) { var r = self.refillByV[v]; return r && offer.indexOf(r.sc) > -1; });
      var picked = this.refills.map(function (v) { return self.refillByV[v].sc; });
      var shownSc = picked.concat(offer.filter(function (sc) { return picked.indexOf(sc) < 0; })).slice(0, Math.max(this.cfg.refillMax || 2, picked.length));
      var refillSum = 0;
      this.refills.forEach(function (v) { refillSum += self.refillByV[v].p; });
      if (this.refillEl) {
        var tt = this.cfg.t, rk = shownSc.join(',') + '|' + this.refills.join(',');
        if (rk !== this._refillKey) {
          this._refillKey = rk;
          this.refillEl.innerHTML = shownSc.length ? '<p class="fs-pack__refill-head">' + escapeHtml(tt.refillHead || '') + '</p>' + shownSc.map(function (sc) {
            var r = self.refillBy[sc], on = self.refills.indexOf(r.v) > -1;
            return '<div class="fs-refill' + (on ? ' is-on' : '') + '">' +
              (r.img ? '<img src="' + r.img + '" alt="" loading="lazy" width="80" height="80">' : '') +
              '<span class="fs-refill__copy"><b>' + escapeHtml((tt.refillLine || 'Add the [scent] refill').replace('[scent]', r.t)) + '</b>' +
              '<small>' + escapeHtml((tt.refillSub || '[fills] more fills · [price]').replace('[fills]', self.cfg.refillFills || '4').replace('[price]', FS.money(r.p))) + '</small></span>' +
              '<button type="button" class="fs-refill__btn" data-fs-refill-toggle="' + r.v + '" aria-pressed="' + on + '">' +
              (on ? '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7"/></svg> ' + escapeHtml(tt.refillAdded || 'Added') : '+ ' + escapeHtml(tt.refillAdd || 'Add')) + '</button></div>';
          }).join('') : '';
        }
        this.refillEl.hidden = !shownSc.length;
      }
      // totals
      var base = 0, subTotal = 0, packSave = 0;
      var pct = this.cfg.requireFull ? this.tierPct(size) : this.tierPct(n);
      this.picks.forEach(function (v) {
        var p = self.byV[v]; if (!p) return;
        var u = self.unit(p);
        base += p.p; subTotal += u; packSave += Math.round(u * pct / 100);
      });
      var subSave = base - subTotal;
      var per = n ? Math.round((subTotal - packSave) / n) : 0;
      base += refillSum;
      var total = subTotal - packSave + refillSum;
      var showRow = function (sel, on) { self.querySelectorAll(sel).forEach(function (el) { el.hidden = !on; }); };
      showRow('[data-fs-row-pack]', pct > 0 && n > 0);
      showRow('[data-fs-row-sub]', subSave > 0);
      showRow('[data-fs-row-refill]', refillSum > 0);
      this.querySelectorAll('[data-fs-refill-sum]').forEach(function (el) { el.textContent = '+' + FS.money(refillSum); });
      this.querySelectorAll('[data-fs-subtotal]').forEach(function (el) { el.textContent = FS.money(base - refillSum); });
      this.querySelectorAll('[data-fs-pack-pct]').forEach(function (el) { el.textContent = '−' + pct + '%'; });
      this.querySelectorAll('[data-fs-pack-save]').forEach(function (el) { el.textContent = '−' + FS.money(packSave); });
      this.querySelectorAll('[data-fs-sub-save]').forEach(function (el) { el.textContent = '−' + FS.money(subSave); });
      // the plan's own rate (e.g. 15%), and how many items it covers when some ship one-time
      var subRate = 0, subN = 0;
      this.picks.forEach(function (v) {
        var p = self.byV[v], al = self.alloc(p); if (!p || !al || !p.p) return;
        subN++; subRate = Math.max(subRate, Math.round((p.p - al.p) / p.p * 100));
      });
      this.querySelectorAll('[data-fs-sub-pct]').forEach(function (el) {
        var on = self.cfg.t.subOn ? ' ' + self.cfg.t.subOn.replace('[x]', subN).replace('[n]', n) : '';
        el.textContent = subRate ? '−' + subRate + '%' + (subN < n ? on : '') : '';
      });
      this.querySelectorAll('[data-fs-was]').forEach(function (el) { el.hidden = !(n && total < base); el.textContent = FS.money(base); });
      this.querySelectorAll('[data-fs-saved]').forEach(function (el) {
        var saved = base - total; el.hidden = !(n && saved > 0);
        el.textContent = self.cfg.t.saved.replace('[amount]', FS.money(saved));
      });
      // next-tier nudge
      var nudge = this.querySelector('[data-fs-nudge]');
      if (nudge) {
        var cur = this.tierPct(size), next = null;
        this.cfg.sizes.forEach(function (s2) { if (s2 > size && next === null && self.tierPct(s2) > cur) next = s2; });
        if (next !== null) {
          nudge.hidden = false;
          nudge.innerHTML = '<button type="button" data-fs-size="' + next + '">' + escapeHtml(this.cfg.t.nudge.replace('[size]', next).replace('[pct]', this.tierPct(next))) + ' <span aria-hidden="true">→</span></button>';
        } else if (cur > 0) {
          nudge.hidden = false;
          nudge.innerHTML = '<span>' + escapeHtml(this.cfg.t.nudgeMax.replace('[pct]', cur)) + '</span>';
        } else nudge.hidden = true;
      }
      // subscription toggle state
      if (this.subEnabled) {
        var noPlan = n > 0 && !this.picks.some(function (v) { var p = self.byV[v]; return p && p.sp && p.sp.length; });
        this.subWrap.classList.toggle('is-unavailable', noPlan);
        if (this.subToggle) { this.subToggle.setAttribute('aria-disabled', String(noPlan)); this.subToggle.tabIndex = noPlan ? -1 : 0; }
        var subNote = this.querySelector('[data-fs-sub-none]'); if (subNote) subNote.hidden = !noPlan;
        if (this.subToggle) this.subToggle.setAttribute('aria-checked', String(this.subOn && !noPlan));
        this.subWrap.classList.toggle('is-on', this.subOn && !noPlan);
        // one delivery row per format in the pack (all formats while it's empty); a picker where a format has several plans
        if (this.subPlans) {
          var kinds = ['h', 's', 'v'].filter(function (k) { return self.plansK[k] && perKind[k] > 0; });
          if (!kinds.length) kinds = ['h', 's', 'v'].filter(function (k) { return self.plansK[k]; });
          var every = this.cfg.t.planEvery || 'Every [interval]', lab = this.cfg.t.subLabels || {};
          var pk = this.subOn + '|' + kinds.map(function (k) { return k + ':' + self.planK[k]; }).join(',');
          if (pk !== this._subKey) {
            this._subKey = pk;
            var nice = function (n) { return self.oK[n] ? every.replace('[interval]', self.oK[n]) : n; };
            this.subPlans.innerHTML = kinds.map(function (k) {
              var L = self.plansK[k], cur = self.planK[k];
              var val = L.length > 1
                ? '<div class="fs-select"><select data-fs-plan-kind="' + k + '" aria-label="' + escapeHtml(lab[k] || k) + '">' + L.map(function (n) { return '<option value="' + escapeHtml(n) + '"' + (n === cur ? ' selected' : '') + '>' + escapeHtml(nice(n)) + '</option>'; }).join('') + '</select></div>'
                : '<span class="fs-pack__sub-every">' + escapeHtml(nice(cur)) + '</span>';
              return '<div class="fs-pack__sub-row"><span class="fs-pack__label">' + escapeHtml(lab[k] || k) + '</span>' + val + '</div>';
            }).join('');
          }
          this.subPlans.hidden = !this.subOn;
        }
        var badge = this.querySelector('[data-fs-sub-badge]');
        if (badge) {
          var ref = null;
          this.cfg.products.some(function (p) { return (p.sp || []).some(function (a) { if (p.p) { ref = Math.round((p.p - a.p) / p.p * 100); return true; } return false; }); });
          badge.textContent = ref > 0 ? this.cfg.t.subBadge.replace('[pct]', ref) : '';
          badge.hidden = !(ref > 0);
        }
      }
      this.style.setProperty('--fs-fill', size ? (n / size).toFixed(3) : 0);
      this.querySelectorAll('[data-fs-picked]').forEach(function (el) { el.textContent = n; });
      this.querySelectorAll('[data-fs-size-label]').forEach(function (el) { el.textContent = size; });
      this.querySelectorAll('[data-fs-total]').forEach(function (el) { el.textContent = FS.money(total); });
      this.querySelectorAll('[data-fs-per]').forEach(function (el) { el.textContent = n ? FS.money(per) : '—'; });
      var ready = this.cfg.requireFull ? n === size : n > 0;
      this.cta.forEach(function (b) {
        b.disabled = !ready;
        var lbl = b.querySelector('[data-fs-cta-label]');
        if (lbl) lbl.textContent = ready ? self.cfg.t.ctaReady.replace('[total]', FS.money(total))
          : self.cfg.t.ctaNeed.replace('[left]', size - n);
      });
      this.save();
    }
    submit() {
      var self = this, size = this.size;
      if (this.cfg.requireFull && this.picks.length !== size) return;
      var counts = {}, order = [];
      this.picks.forEach(function (v) { if (!counts[v]) order.push(v); counts[v] = (counts[v] || 0) + 1; });
      var items = order.map(function (v) {
        var it = { id: Number(v), quantity: counts[v] };
        var a = self.alloc(self.byV[v]);
        if (a) it.selling_plan = a.id;
        if (self.cfg.prop) { it.properties = {}; it.properties[self.cfg.prop] = self.cfg.t.packName.replace('[size]', size); }
        return it;
      });
      this.refills.forEach(function (v) { if (self.refillByV[v]) items.push({ id: Number(v), quantity: 1 }); });
      var nRef = this.refills.length;
      this.cta.forEach(function (b) { b.disabled = true; var l = b.querySelector('[data-fs-cta-label]'); if (l) l.textContent = self.cfg.t.adding; });
      FS.addToCart(items).then(function () {
        var n = self.picks.length;
        self.picks = []; self.refills = []; self.render(); self.say(self.cfg.t.added, 'ok'); FS.openCart();
        self.emit('added', { added: n, refills: nRef });
      }).catch(function (err) { self.render(); self.say(err.message, 'error'); });
    }
  });
  // "Formula Creed", "Formula Spray – Creed", "Mornin’ Wood" → one key per scent across formats
  function scentKey(t) {
    return String(t || '').toLowerCase().replace(/[‘’`]/g, "'").replace(/^formula\s+/, '').replace(/\s+/g, ' ').trim();
  }

  /* ---------- Limited-drop "Notify me" (grid + product pages) ----------
     Email → Klaviyo Back in Stock subscription per variant (Klaviyo's own "Subscribed to Back in Stock"
     trigger fires the flow when Shopify stock comes back). Ticked consent → Klaviyo list.
     Texts → TxtCart keyword; US visitors see the US number, Canadians the CA one. */
  var KLV_REV = '2024-10-15';
  function klv(path, key, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(key), {
      method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: KLV_REV }, body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('klaviyo ' + r.status); return r; });
  }
  FS.klaviyoBIS = function (key, email, variantIds) {
    return Promise.all(variantIds.map(function (v) {
      return klv('back-in-stock-subscriptions', key, { data: { type: 'back-in-stock-subscription',
        attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email } } } },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + v } } } } });
    }));
  };
  FS.klaviyoList = function (key, list, email) {
    return klv('subscriptions', key, { data: { type: 'subscription',
      attributes: { custom_source: 'Limited drop notify', profile: { data: { type: 'profile', attributes: { email: email,
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
      relationships: { list: { data: { type: 'list', id: list } } } } });
  };
  function smsLine(box) {
    var el = box.querySelector('[data-fs-sms]'); if (!el) return;
    var paint = function (cc) {
      var k = cc === 'US' ? 'us' : (cc === 'CA' ? 'ca' : null);
      var num = k && el.dataset[k], dig = k && el.dataset[k + 'D'];
      if (!num) { el.hidden = true; return; }
      if (dig.charAt(0) !== '+') dig = (dig.length === 10 ? '+1' : '+') + dig;
      var kw = el.dataset.kw, txt = el.dataset.text || 'Prefer a text? Text [keyword] to [number]';
      var html = escapeHtml(txt).split('[keyword]').join('<b>' + escapeHtml(kw) + '</b>').split('[number]').join('<span class="fs-nowrap">' + escapeHtml(num) + '</span>');
      el.innerHTML = '<a href="sms:' + dig + '?&body=' + encodeURIComponent(kw) + '">' + html + '</a>';
      el.hidden = false;
    };
    if (FS._cc) return paint(FS._cc);
    paint(el.dataset.market);
    fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var cc = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
      if (cc) { FS._cc = cc; paint(cc); }
    }).catch(function () {});
  }
  var nBox = null, nIds = [], nRet = null;
  function nClose() { if (!nBox) return; nBox.hidden = true; if (nRet && nRet.focus) nRet.focus(); }
  function nInit() {
    if (nBox) return nBox;
    nBox = document.getElementById('FsNotify'); if (!nBox) return null;
    nBox.addEventListener('click', function (e) { if (e.target === nBox || e.target.closest('[data-fs-notify-close]')) nClose(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && nBox && !nBox.hidden) nClose(); });
    nBox.querySelector('[data-fs-notify-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      var f = e.currentTarget, d = nBox.dataset;
      var input = f.querySelector('input[type=email]'), msg = f.querySelector('[data-fs-notify-msg]'), btn = f.querySelector('[data-fs-notify-submit]');
      var fields = f.querySelector('[data-fs-notify-fields]'), consent = f.querySelector('[data-fs-notify-consent]'), crow = f.querySelector('[data-fs-notify-consent-row]');
      var email = String(input && input.value || '').trim();
      var say = function (txt, kind) { msg.textContent = txt || ''; msg.className = 'fs-notify__msg' + (kind ? ' is-' + kind : ''); };
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { say(d.err, 'error'); input.focus(); return; }
      btn.disabled = true; say(d.sending, '');
      var jobs = [FS.klaviyoBIS(d.key, email, nIds)];
      if (consent && consent.checked && d.list) jobs.push(FS.klaviyoList(d.key, d.list, email));
      Promise.all(jobs).then(function () {
        btn.disabled = false; fields.hidden = true; if (crow) crow.hidden = true; say(d.ok, 'ok');
        try { window.dispatchEvent(new CustomEvent('fs:notify:done', { detail: { ids: nIds } })); } catch (er) {}
      }).catch(function () { btn.disabled = false; say(d.err, 'error'); });
    });
    return nBox;
  }
  FS.notifyOpen = function (name, ids) {
    var box = nInit(); if (!box) return;
    nIds = (ids || []).map(Number).filter(Boolean);
    box.querySelector('[data-fs-notify-name]').textContent = name || '';
    var fields = box.querySelector('[data-fs-notify-fields]'), msg = box.querySelector('[data-fs-notify-msg]'), crow = box.querySelector('[data-fs-notify-consent-row]');
    fields.hidden = false; if (crow) { crow.hidden = false; var cb = crow.querySelector('input'); if (cb) cb.checked = false; } msg.textContent = ''; msg.className = 'fs-notify__msg';
    nRet = document.activeElement; box.hidden = false; smsLine(box);
    var f = box.querySelector('input[type=email]'); if (f) setTimeout(function () { f.focus(); }, 30);
  };
  // product page: show "Notify me when it drops" while the selected variant is a sold-out drop variant
  define('fs-drop-notify', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.ids = (this.dataset.ids || '').split(',').map(Number).filter(Boolean);
      this.form = (this.closest('product-info, .product, section') || document).querySelector('form[action*="/cart/add"]');
      this.check = function () {
        var inp = self.form && self.form.querySelector('[name="id"]');
        var m = window.location.search.match(/[?&]variant=(\d+)/);
        var cur = String((inp && inp.value) || (m && m[1]) || '');
        self.hidden = !(cur && self.dataset.sold.indexOf(',' + cur + ',') > -1);
      };
      this.later = function () { self.check(); setTimeout(self.check, 150); setTimeout(self.check, 700); };
      document.addEventListener('change', this.later); window.addEventListener('popstate', this.later);
      this.addEventListener('click', function (e) { if (e.target.closest('[data-fs-drop-open]')) FS.notifyOpen(self.dataset.name, self.ids); });
      this.check();
    }
    disconnectedCallback() { document.removeEventListener('change', this.later); window.removeEventListener('popstate', this.later); }
  });

  FS.installSubGuard = FS.installSubGuard || function () {};

  /* ---------- Product page: subscribe checkbox (drives Seal selling plans) ---------- */
  define('fs-subscribe', class extends HTMLElement {
    connectedCallback() {
      var dataEl = this.querySelector('script[data-fs-sub-data]');
      if (!dataEl) return;
      try { this.cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var self = this;
      this.check = this.querySelector('[data-fs-sub-check]');
      this.input = this.querySelector('[data-fs-plan-input]');
      this.select = this.querySelector('[data-fs-sub-select]');
      this.planWrap = this.querySelector('[data-fs-sub-plan]');
      this.variant = String(this.cfg.current);
      this.planName = null;
      this.check.addEventListener('change', function () { self.update(); });
      if (this.select) this.select.addEventListener('change', function () { self.planName = self.select.value; self.update(); });
      // Follow variant changes from the theme's picker
      var form = document.getElementById(this.dataset.form);
      this.idInput = form ? form.querySelector('input[name="id"]') : null;
      var sync = function () {
        var v = self.idInput && self.idInput.value;
        if (v && v !== self.variant && self.cfg.variants[v]) { self.variant = v; self.update(); }
      };
      if (this.idInput) {
        this.idInput.addEventListener('change', sync);
        document.addEventListener('change', function () { setTimeout(sync, 0); });
        document.addEventListener('click', function () { setTimeout(sync, 60); });
      }
      // If Seal still injects its own widget, keep its selling_plan inputs out of the form so
      // this checkbox is the only thing deciding one-time vs subscription.
      this.quash();
      if ('MutationObserver' in window) {
        var pending = false;
        this._mo = new MutationObserver(function () { if (pending) return; pending = true; setTimeout(function () { pending = false; self.quash(); }, 50); });
        this._mo.observe(document.body, { childList: true, subtree: true });
        setTimeout(function () { if (self._mo) self._mo.disconnect(); }, 15000);
      }
      this.update();
    }
    // If Seal's own (hidden) widget is on the page, flip it to match so its script agrees.
    syncSeal(on) {
      try {
        var info = this.closest('.product__info-container') || document;
        var radios = info.querySelectorAll('[class*="sls-"] input[type="radio"]');
        if (!radios.length) return;
        var pick = null;
        radios.forEach(function (r) {
          var lbl = (r.closest('label') || r.parentElement || r).textContent || '';
          var oneTime = /one[\s-]?time|single|once/i.test(lbl);
          if (on ? !oneTime : oneTime) { if (!pick) pick = r; }
        });
        if (pick && !pick.checked) pick.click();
      } catch (e) {}
    }
    quash() {
      var mine = this.input, formId = this.dataset.form;
      document.querySelectorAll('[name="selling_plan"]').forEach(function (el) {
        if (el === mine) return;
        var f = el.form || el.closest('form');
        if (!f || f.id === formId) el.disabled = true;
      });
      document.documentElement.classList.add('fs-has-sub-check');
    }
    plans() { return this.cfg.variants[this.variant] || []; }
    update() {
      var plans = this.plans(), on = this.check.checked && plans.length > 0;
      if (this.select) {
        var names = plans.map(function (a) { return a.n; }), eo = this.cfg.everyOpt || 'Every [interval]';
        var html = plans.map(function (a) { return '<option value="' + escapeHtml(a.n) + '">' + escapeHtml(a.o ? eo.replace('[interval]', a.o) : a.n) + '</option>'; }).join('');
        if (this.select.innerHTML !== html) this.select.innerHTML = html;
        if (!this.planName || names.indexOf(this.planName) < 0) this.planName = names[0] || null;
        if (this.planName) this.select.value = this.planName;
      }
      var plan = null, name = this.planName;
      plans.forEach(function (a) { if (!plan && a.n === name) plan = a; });
      if (!plan) plan = plans[0] || null;
      this.hidden = plans.length === 0;
      this.classList.toggle('is-on', on);
      if (this.planWrap) this.planWrap.hidden = !(on && plans.length > 1);
      if (this.input) { this.input.disabled = !on || !plan; this.input.value = on && plan ? plan.id : ''; }
      // Plan details straight from the Seal plan for this exact variant: its description,
      // and the later-order price when the plan changes price after the first order(s).
      var detail = this.querySelector('[data-fs-sub-detail]');
      if (detail) {
        var lines = [];
        if (plan && plan.o && this.cfg.every && plans.length === 1) lines.push(this.cfg.every.replace('[interval]', plan.o));
        if (plan && plan.adj && plan.adj.length > 1 && plan.adj[plan.adj.length - 1] !== plan.adj[0]) {
          lines.push((this.cfg.then || '').replace('[first]', FS.money(plan.adj[0])).replace('[later]', FS.money(plan.adj[plan.adj.length - 1])));
        }
        if (plan && plan.d) lines.push(plan.d);
        detail.innerHTML = lines.map(function (l) { return '<span>' + escapeHtml(l) + '</span>'; }).join('');
        detail.hidden = !lines.length;
      }
      if (plan) {
        var was = this.querySelector('[data-fs-sub-was]'), now = this.querySelector('[data-fs-sub-now]'), badge = this.querySelector('[data-fs-sub-pct]');
        var pct = plan.c > plan.p ? Math.round((plan.c - plan.p) / plan.c * 100) : 0;
        if (now) now.textContent = FS.money(plan.p);
        if (was) { was.textContent = FS.money(plan.c); was.hidden = pct <= 0; }
        if (badge) { badge.textContent = (this.cfg.badge || '−[pct]%').replace('[pct]', pct); badge.hidden = pct <= 0; }
      }
      // The checkbox is the single source of truth for what gets added to the cart.
      FS.subState = { variant: String(this.variant), on: !!(on && plan), plan: plan ? plan.id : null };
      FS.installSubGuard();
      this.syncSeal(on);
      this.dispatchEvent(new CustomEvent('fs:subscribe', { bubbles: true, detail: { on: on, plan: plan } }));
    }
  });

  /* ---------- How to use: pinned step sequence on the brand's own images ---------- */
  define('fs-howto', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-fs-ht-slide]'));
      this.n = this.slides.length;
      if (!this.n) return;
      this.texts = this.querySelectorAll('[data-fs-ht-text]');
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-fs-ht-tab]'));
      this.bars = this.tabs.map(function (b) { return b.querySelector('.fs-howto__tab-bar span'); });
      this.nums = this.querySelectorAll('[data-fs-ht-num]');
      this.track = this.querySelector('[data-fs-ht-track]');
      this.car = this.querySelector('[data-fs-ht-car]');
      try { this.trackLen = this.track.getTotalLength(); } catch (e) { this.trackLen = 0; }
      this.isStatic = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.classList.toggle('is-static', this.isStatic);
      this.cur = this.target = 0;
      this.tabs.forEach(function (b) { b.addEventListener('click', function () { self.go(Number(b.dataset.fsHtTab)); }); });
      this.slides.forEach(function (sl, i) { sl.addEventListener('click', function () { if (self.isStatic) self.go(Math.min(self.n - 1, i + 1 === self.n ? 0 : i + 1)); }); });
      this._onScroll = function () { self.measure(); self.loop(); };
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll);
      this._onSelect = function (e) {
        var sl = e.target && e.target.closest && e.target.closest('[data-fs-ht-slide]');
        if (sl && self.contains(sl)) self.go(Number(sl.dataset.fsHtSlide), true);
      };
      document.addEventListener('shopify:block:select', this._onSelect);
      // Swipe on the stage (mobile)
      var stage = this.querySelector('.fs-howto__stage'), x0 = null;
      if (stage) {
        stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
          if (Math.abs(dx) > 40) self.go(Math.max(0, Math.min(self.n - 1, self.idx() + (dx < 0 ? 1 : -1))));
        }, { passive: true });
      }
      this.measure(); this.cur = this.target; this.render(); this.loop();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
      document.removeEventListener('shopify:block:select', this._onSelect);
    }
    total() { var pin = this.firstElementChild; return this.offsetHeight - (pin ? pin.offsetHeight : window.innerHeight); }
    measure() {
      if (this.isStatic) return;
      var total = this.total(); if (total <= 0) return;
      var f = Math.min(1, Math.max(0, -this.getBoundingClientRect().top / total));
      // n equal stretches: the first holds image 1; each later stretch wipes its image in over
      // the first 45%, then holds it.
      var p = f * this.n, i = Math.min(this.n - 1, Math.floor(p)), local = p - i;
      this.target = i === 0 ? 0 : (i - 1) + Math.min(1, local / 0.45);
      if (f >= 1) this.target = this.n - 1;
    }
    idx() { return Math.max(0, Math.min(this.n - 1, Math.round(this.cur))); }
    go(i, instant) {
      if (this.isStatic || instant) { this.target = this.cur = i; this.render(); }
      if (this.isStatic) return;
      var total = this.total();
      var top = window.scrollY + this.getBoundingClientRect().top + total * ((i + 0.6) / this.n);
      window.scrollTo({ top: top, behavior: instant ? 'auto' : 'smooth' });
    }
    loop() {
      if (this._raf) return;
      var self = this;
      var tick = function () {
        self._raf = null;
        var d = self.target - self.cur;
        self.cur = Math.abs(d) < 0.002 ? self.target : self.cur + d * 0.14;
        self.render();
        if (self.cur !== self.target) self._raf = requestAnimationFrame(tick);
      };
      this._raf = requestAnimationFrame(tick);
    }
    render() {
      var p = this.cur, n = this.n, idx = this.idx();
      this.slides.forEach(function (sl, i) {
        var r = i === 0 ? 1 : Math.max(0, Math.min(1, p - (i - 1)));
        sl.style.setProperty('--r', r.toFixed(4));
        sl.classList.toggle('is-wiping', r > 0.001 && r < 0.999);
        sl.style.visibility = r <= 0.001 ? 'hidden' : 'visible';
      });
      if (idx !== this._idx) {
        this._idx = idx;
        var label = (idx + 1 < 10 ? '0' : '') + (idx + 1);
        this.nums.forEach(function (el) { el.textContent = label; });
        this.texts.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
        this.tabs.forEach(function (b, i) { b.classList.toggle('is-active', i === idx); b.setAttribute('aria-current', i === idx ? 'step' : 'false'); });
      }
      var self = this;
      this.bars.forEach(function (bar, i) {
        if (!bar) return;
        var f = i === 0 ? 1 : Math.max(0, Math.min(1, p - (i - 1)));
        bar.style.transform = 'scaleX(' + f.toFixed(3) + ')';
      });
      var prog = n > 1 ? p / (n - 1) : 1;
      if (this.track) this.track.style.strokeDashoffset = (1 - prog).toFixed(4);
      if (this.car && this.trackLen) { var pt = this.track.getPointAtLength(this.trackLen * prog); this.car.setAttribute('cx', pt.x); this.car.setAttribute('cy', pt.y); }
    }
  });

  /* ---------- Setup builder: lineup → builds (scent → extras) → garage ---------- */
  define('fs-setup', class extends HTMLElement {
    connectedCallback() {
      var el = this.querySelector('script[data-fs-setup-data]');
      if (!el) return;
      try { this.d = JSON.parse(el.textContent); } catch (e) { return; }
      var self = this, t = this.d.t;
      this.t = t; this.cfg = this.d.cfg || {};
      this.F = ['diffuser', 'vent', 'spray'];
      this.$ = function (sel) { return self.querySelector(sel); };
      this.$$ = function (sel) { return Array.prototype.slice.call(self.querySelectorAll(sel)); };
      this.catalog = this.buildCatalog();
      this.tiers = String(this.cfg.tiers || '').split(',').map(function (x) { var p = x.split(':'); return { q: parseInt(p[0], 10), pct: parseFloat(p[1]) }; })
        .filter(function (x) { return x.q > 0 && x.pct > 0; }).sort(function (a, b) { return a.q - b.q; });
      var tn = String(this.cfg.tierNames || '').split(',');
      this.tiers.forEach(function (x, i) { x.name = (tn[i] || '').trim(); });
      this.gifts = (this.cfg.gifts || []).filter(function (g) { return g && g.amount > 0; }).sort(function (a, b) { return a.amount - b.amount; });
      this.cartUnits = 0; this.cartValue = 0; this.cartItems = [];
      this.refillFor = String(this.cfg.refillFor || 'diffuser,vent').split(',');
      this.max = this.cfg.maxQty || 6; this.maxAdd = this.cfg.maxAdd || 4;
      this.stage = this.$('[data-fs-stage-inner]');
      this._seen = {};
      // Format availability + "from" prices
      this.avail = {};
      this.F.forEach(function (f) {
        var min = Infinity;
        self.catalog.forEach(function (s) { var b = self.baseLine(s, f); if (b && b.p < min) min = b.p; });
        self.avail[f] = isFinite(min);
        var from = self.querySelector('[data-fs-from="' + f + '"]');
        if (from) from.textContent = isFinite(min) ? t.from.replace('[price]', FS.money(min)) : '';
        var card = self.querySelector('[data-fs-format="' + f + '"]');
        if (card) card.hidden = !isFinite(min);
      });
      this.fresh();
      this.addEventListener('click', this.onClick.bind(this));
      var sel = this.$('[data-fs-sub-select]');
      if (sel) sel.addEventListener('change', function () { self.state.plan = sel.value; self.save(); self.render(); });
      this.addEventListener('change', function (e) {
        var g = e.target.closest && e.target.closest('[data-fs-gift-select]'); if (!g) return;
        self.state.gifts = self.state.gifts || {}; self.state.gifts[g.dataset.fsGiftSelect] = g.value; self.save(); self.render();
      });
      this.restore();
      this.render();
      this.loadCart();
      window.addEventListener('pageshow', function (e) { if (e.persisted) self.loadCart(); });
      document.addEventListener('visibilitychange', function () { if (!document.hidden) self.loadCart(); });
    }

    /* ----- live cart ----- */
    cartRoot() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
    loadCart() {
      var self = this;
      if (!window.fetch) return Promise.resolve();
      return fetch(this.cartRoot() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { self.readCart(c); self.render(); return c; })
        .catch(function () {});
    }
    unitIds() {
      if (this._unitIds) return this._unitIds;
      var ids = {};
      this.catalog.forEach(function (s) {
        if (s.diffuser) { ids[s.diffuser.v] = 1; (s.diffuser.vs || []).forEach(function (x) { ids[x.v] = 1; }); }
        if (s.vent && s.vent.kit) ids[s.vent.kit.v] = 1;
        if (s.spray) ids[s.spray.v] = 1;
      });
      return (this._unitIds = ids);
    }
    isGiftLine(it) {
      for (var i = 0; i < this.gifts.length; i++) if (this.gifts[i].pid && this.gifts[i].pid === it.product_id) return true;
      return /shipping protection|sample spray/i.test(it.product_title || it.title || '');
    }
    readCart(c) {
      var self = this, ids = this.unitIds(), units = 0, value = 0;
      this.cartItems = (c && c.items) || [];
      var mine = this.state && this.state.gid ? this.state.gid + '-' : null;
      this.inCart = {};
      this.cartItems.forEach(function (it) {
        if (self.isGiftLine(it)) return;
        var tag = it.properties && it.properties._fs_g;
        // lines this garage already put in the cart are counted through the garage itself, not twice
        if (mine && tag && String(tag).indexOf(mine) === 0) { self.inCart[tag] = (self.inCart[tag] || 0) + it.quantity; return; }
        if (ids[it.variant_id]) units += it.quantity;
        value += typeof it.final_line_price === 'number' ? it.final_line_price : it.line_price;
      });
      this.cartUnits = units; this.cartValue = value;
    }

    /* ----- data ----- */
    fresh(keepSub) {
      var sub = keepSub && this.state ? this.state.sub : !!this.cfg.subDefault;
      var plan = keepSub && this.state ? this.state.plan : null;
      this.state = { view: 'lineup', builds: [], cur: 0, sub: sub, plan: plan, fam: 'all', uid: 1, gid: Date.now().toString(36) + Math.random().toString(36).slice(2, 6) };
    }
    norm(n) {
      return String(n || '').toLowerCase().replace(/[’'`]/g, '').replace(/irresistable/g, 'irresistible').replace(/^formula\s+/, '').replace(/[^a-z0-9]+/g, ' ').trim();
    }
    buildCatalog() {
      var d = this.d, self = this, map = {}, order = [];
      var get = function (name) {
        var k = self.norm(name); if (!k) return null;
        if (!map[k]) { map[k] = { key: k, name: name, img: '', notes: '', fam: '', insp: '', hide: false, diffuser: null, vent: {}, spray: null, refill: null }; order.push(k); }
        return map[k];
      };
      (d.scents || []).forEach(function (b) { var s = get(b.n); if (!s) return; s.name = b.n; s.img = b.img; s.notes = b.notes; s.fam = b.fam; s.insp = b.insp; s.hide = b.hide; s.drop = !!b.drop; });
      (d.diffusers || []).forEach(function (p) {
        var s = get(p.n); if (!s) return;
        s.diffuser = { v: p.v, p: p.p, a: p.a, sp: p.sp || [], img: p.img, title: p.n };
        s.url = p.url;
        if (p.vs && p.vs.length > 1) s.diffuser.vs = p.vs.map(function (x) { return { key: self.norm(x.n), n: x.n, v: x.v, p: x.p, a: x.a, sp: x.sp || [], img: x.img || p.img, title: p.n }; });
        if (p.vs && p.vs.length > 1) s.diffuser.a = p.vs.some(function (x) { return x.a; });
        if (!s.insp && p.insp) s.insp = p.insp;
      });
      var m = this.cfg.ventMatch || {};
      var has = function (a, b) { return b && String(a || '').toLowerCase().indexOf(String(b).toLowerCase()) > -1; };
      if (d.vent) d.vent.variants.forEach(function (v) {
        var s = get(v.o1); if (!s) return;
        var line = { v: v.v, p: v.p, a: v.a, sp: v.sp || [], img: v.img || d.vent.img, title: d.vent.title };
        // The "vent + refill" bundle is skipped on purpose: the refill is offered on its own.
        if (has(v.o2, m.refill)) return;
        if (has(v.o2, m.sticks)) s.vent.sticks = line;
        else if (!s.vent.kit || has(v.o2, m.kit)) s.vent.kit = line;
      });
      ['spray', 'refill'].forEach(function (k) {
        if (d[k]) d[k].variants.forEach(function (v) { var s = get(v.o1); if (s) s[k] = { v: v.v, p: v.p, a: v.a, sp: v.sp || [], img: v.img || d[k].img, title: d[k].title }; });
      });
      return order.map(function (k) { return map[k]; }).filter(function (s) { return !s.hide && (s.diffuser || s.vent.kit || s.spray); });
    }
    baseLine(s, f, vk) {
      if (!s) return null;
      var l = f === 'diffuser' ? s.diffuser : f === 'vent' ? s.vent.kit : f === 'spray' ? s.spray : null;
      if (l && l.vs) {
        var pick = null;
        l.vs.forEach(function (x) { if (x.a && (!pick || (vk && x.key === vk && pick.key !== vk))) pick = x; });
        return pick;
      }
      return l && l.a ? l : null;
    }
    hasLine(s, f) { return !!(s && (f === 'diffuser' ? s.diffuser : f === 'vent' ? s.vent.kit : s.spray)); }
    lineOf(b) { return b ? this.baseLine(this.scentFor(b.s), b.f, b.vk) : null; }
    finishes(b) {
      var s = b && b.f === 'diffuser' ? this.scentFor(b.s) : null;
      return s && s.diffuser && s.diffuser.vs ? s.diffuser.vs.filter(function (x) { return x.a; }) : [];
    }
    scentFor(key) { for (var i = 0; i < this.catalog.length; i++) if (this.catalog[i].key === key) return this.catalog[i]; return null; }
    baseImg(f) {
      var b = this.cfg.bases || {};
      if (b[f]) return { src: b[f], ghost: false };
      var d = this.d, src = f === 'vent' && d.vent ? d.vent.img : f === 'spray' && d.spray ? d.spray.img : (d.diffusers && d.diffusers[0] ? d.diffusers[0].img : '');
      return { src: src || '', ghost: true };
    }
    cur() { return this.state.builds[this.state.cur] || null; }
    done(b) { return !!(b && b.s && this.lineOf(b)); }
    count(f) { return this.state.builds.filter(function (b) { return b.f === f; }).length; }
    nOf(b) { var n = 0, bs = this.state.builds; for (var i = 0; i < bs.length; i++) { if (bs[i].f === b.f) n++; if (bs[i] === b) return n; } return n; }
    newBuild(f, s, from) { return { id: this.state.uid++, f: f, s: s || null, adds: {}, from: from || null }; }
    addonDefs(b) {
      var s = b && this.scentFor(b.s), t = this.t, w = this.cfg.weeks, out = [];
      if (!s) return out;
      var ok = function (l) { return l && l.a; };
      if (this.refillFor.indexOf(b.f) > -1 && ok(s.refill)) out.push({ key: 'refill', title: t.addRefill, text: t.addRefillText, line: s.refill, weeks: w.refill });
      if (b.f === 'vent' && ok(s.vent.sticks)) out.push({ key: 'sticks', title: t.addSticks, text: t.addSticksText, line: s.vent.sticks, weeks: w.sticks });
      return out;
    }
    buildLines(b) {
      var s = this.scentFor(b.s), base = this.lineOf(b), out = [];
      if (!base) return out;
      out.push({ role: 'base', line: base, q: 1, label: this.t[b.f] });
      this.addonDefs(b).forEach(function (a) { var q = b.adds[a.key] || 0; if (q > 0) out.push({ role: a.key, line: a.line, q: q, label: a.title }); });
      return out;
    }
    allLines() {
      var self = this, out = [];
      this.state.builds.forEach(function (b, i) { if (self.done(b)) self.buildLines(b).forEach(function (l) { l.b = b; l.i = i; out.push(l); }); });
      return out;
    }
    weeks(b) {
      var w = this.cfg.weeks, segs = [];
      if (!b) return { total: 0, segs: segs };
      if (b.f === 'diffuser') segs.push({ label: this.t.diffuser, n: w.diffuser });
      if (b.f === 'vent') segs.push({ label: this.t.vent, n: w.vent });
      this.addonDefs(b).forEach(function (a) { for (var q = 0; q < (b.adds[a.key] || 0); q++) segs.push({ label: a.title, n: a.weeks }); });
      return { total: segs.reduce(function (x, s) { return x + s.n; }, 0), segs: segs };
    }
    planFor(line) {
      if (!this.state.sub || !line.sp || !line.sp.length) return null;
      for (var i = 0; i < line.sp.length; i++) if (line.sp[i].n === this.state.plan) return line.sp[i];
      return line.sp[0];
    }
    unit(l) { var p = this.planFor(l.line); return p ? p.p : l.line.p; }
    buildPrice(b) { var self = this; return this.buildLines(b).reduce(function (x, l) { return x + self.unit(l) * l.q; }, 0); }
    planNames() {
      var names = [], seen = {};
      this.allLines().forEach(function (l) { (l.line.sp || []).forEach(function (p) { if (!seen[p.n]) { seen[p.n] = 1; names.push(p.n); } }); });
      return names;
    }
    planEvery(p) {
      var t = this.t || {};
      return p && p.o ? (t.every || 'Every [interval]').replace('[interval]', p.o) : '';
    }
    planLabel(n) {
      var hit = null;
      this.allLines().forEach(function (l) { (l.line.sp || []).forEach(function (p) { if (!hit && p.n === n && p.o) hit = p; }); });
      return hit ? n + ' \u2014 ' + this.planEvery(hit).toLowerCase() : n;
    }
    pack() {
      if (!this.cfg.pack || !this.tiers.length) return null;
      var self = this, n = this.cartUnits || 0, sum = 0;
      this.state.builds.forEach(function (b) { if (self.done(b)) { n++; sum += self.unit({ line: self.lineOf(b) }); } });
      var cur = null, next = null;
      this.tiers.forEach(function (x) { if (x.q <= n) cur = x; else if (!next) next = x; });
      return { n: n, cur: cur, next: next, save: cur ? Math.round(sum * cur.pct / 100) : 0 };
    }
    garageTotal() {
      var self = this, pk = this.pack();
      var tot = this.allLines().reduce(function (x, l) { return x + self.unit(l) * l.q; }, 0);
      return Math.max(0, tot - (pk ? pk.save : 0));
    }
    giftState() {
      var value = (this.cartValue || 0) + this.garageTotal(), next = null, got = [];
      this.gifts.forEach(function (g) { if (value >= g.amount) got.push(g); else if (!next) next = g; });
      return { value: value, next: next, got: got, top: this.gifts.length ? this.gifts[this.gifts.length - 1].amount : 0 };
    }
    giftVariant(g, key) {
      var self = this;
      for (var i = 0; i < (g.variants || []).length; i++) if (self.norm(g.variants[i].n) === key) return g.variants[i];
      return null;
    }

    /* ----- navigation ----- */
    firstOpen() { var bs = this.state.builds; for (var i = 0; i < bs.length; i++) if (!this.done(bs[i])) return i; return -1; }
    canGarage() { var self = this; return this.state.builds.some(function (b) { return self.done(b); }); }
    open(i, view) {
      var st = this.state, b = st.builds[i]; if (!b) return;
      st.cur = i; st.view = view || (this.done(b) ? 'extras' : 'scent');
      this.go();
    }
    go(view) {
      if (view) this.state.view = view;
      this.save(); this.render();
      var top = this.getBoundingClientRect().top + window.scrollY - (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--fs-header-sticky')) || 0) - 8;
      var rail = this.$('.fs-cfg__rail-wrap'); if (rail) top = rail.getBoundingClientRect().top + window.scrollY - 70;
      if (window.scrollY > top + 40) window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    next() {
      var st = this.state;
      if (st.view === 'lineup') { if (!st.builds.length) return; var o = this.firstOpen(); return o > -1 ? this.open(o, 'scent') : this.go('garage'); }
      if (st.view === 'scent') { if (this.done(this.cur())) this.go('extras'); return; }
      if (st.view === 'extras') {
        for (var i = st.cur + 1; i < st.builds.length; i++) if (!this.done(st.builds[i])) return this.open(i, 'scent');
        var o2 = this.firstOpen(); if (o2 > -1 && o2 !== st.cur) return this.open(o2, 'scent');
        return this.go('garage');
      }
      if (st.view === 'garage') return this.submit();
    }
    back() {
      var st = this.state;
      if (st.view === 'scent') { if (st.cur > 0) return this.open(st.cur - 1, this.done(st.builds[st.cur - 1]) ? 'extras' : 'scent'); return this.go('lineup'); }
      if (st.view === 'extras') return this.go('scent');
      if (st.view === 'garage') { var i = st.builds.length - 1; return i > -1 ? this.open(i) : this.go('lineup'); }
    }
    setQty(f, d) {
      var st = this.state, bs = st.builds;
      if (d > 0) { if (this.count(f) >= this.max || !this.avail[f]) return; bs.push(this.newBuild(f)); }
      else {
        var idx = -1, i;
        for (i = bs.length - 1; i >= 0; i--) if (bs[i].f === f && !bs[i].s) { idx = i; break; }
        if (idx < 0) for (i = bs.length - 1; i >= 0; i--) if (bs[i].f === f) { idx = i; break; }
        if (idx > -1) this.removeAt(idx, true);
      }
      // Keep builds grouped by format in lineup order
      var F = this.F; bs.sort(function (a, b) { return F.indexOf(a.f) - F.indexOf(b.f) || a.id - b.id; });
      st.cur = Math.min(st.cur, Math.max(0, bs.length - 1));
      this.save(); this.render();
    }
    removeAt(i, quiet) {
      var st = this.state, gone = st.builds[i]; if (!gone) return;
      st.builds.splice(i, 1);
      st.builds.forEach(function (b) { if (b.from === gone.id) b.from = null; });
      if (st.cur >= st.builds.length) st.cur = Math.max(0, st.builds.length - 1);
      if (quiet) return;
      if (!st.builds.length) st.view = 'lineup';
      else if ((st.view === 'scent' || st.view === 'extras') && st.cur === i) st.view = this.done(this.cur()) ? 'extras' : 'scent';
      if (st.view === 'garage' && !this.canGarage()) st.view = 'lineup';
      this.save(); this.render();
    }
    append(f, s, from, stay) {
      var st = this.state;
      if (this.count(f) >= this.max) { this.say(this.t.units.replace('[n]', this.max), 'error'); return null; }
      var b = this.newBuild(f, s, from); st.builds.push(b);
      this._flash = b.id;
      if (!stay) { st.cur = st.builds.length - 1; st.view = s ? 'extras' : 'scent'; this.go(); }
      else { this.save(); this.render(); }
      return b;
    }
    onClick(e) {
      var b = e.target.closest('button'); if (!b || !this.contains(b)) return;
      var st = this.state, ds = b.dataset, self = this;
      this.say('');
      if (st.view === 'done' && !b.hasAttribute('data-fs-again') && !b.hasAttribute('data-fs-open-cart')) return;
      if (ds.fsQty) return this.setQty(ds.fsQty, Number(ds.fsD));
      if (ds.fsScent) return this.pickScent(ds.fsScent);
      if (ds.fsFam) { st.fam = ds.fsFam; this.render(); return; }
      if (ds.fsAdd) {
        var c = this.cur(); if (!c) return;
        var q = Math.max(0, Math.min(this.maxAdd, (c.adds[ds.fsAdd] || 0) + Number(ds.fsD || 1)));
        c.adds[ds.fsAdd] = q; this.save(); this.render(); return;
      }
      if (ds.fsCross) {
        var cb = this.cur(); if (!cb) return;
        var linked = this.linked(cb, ds.fsCross);
        if (linked > -1) return this.removeAt(linked);
        return this.append(ds.fsCross, cb.s, cb.id, true);
      }
      if (ds.fsVar !== undefined) { var vb = this.cur(); if (vb) { vb.vk = ds.fsVar; this._fill = vb.id; this.save(); this.render(); } return; }
      if (ds.fsGift) { var gp = ds.fsGift.split('|'); st.gifts = st.gifts || {}; st.gifts[gp[0]] = st.gifts[gp[0]] === gp[1] ? 'mystery' : gp[1]; this.save(); this.render(); return; }
      if (ds.fsComplete) { var p = ds.fsComplete.split('|'); return this.append(p[0], p[1], null, true); }
      if (ds.fsNew) { this.$$('.fs-cfg__rail-add').forEach(function (x) { x.classList.remove('is-open'); }); return this.append(ds.fsNew); }
      if (ds.fsOpen !== undefined) return this.open(Number(ds.fsOpen));
      if (ds.fsRemove !== undefined) return this.removeAt(Number(ds.fsRemove));
      if (ds.fsRail === 'lineup') return this.go('lineup');
      if (ds.fsRail === 'garage') { if (this.canGarage()) this.go('garage'); return; }
      if (b.hasAttribute('data-fs-add-menu')) { b.parentNode.classList.toggle('is-open'); b.setAttribute('aria-expanded', String(b.parentNode.classList.contains('is-open'))); return; }
      if (b.hasAttribute('data-fs-back')) return this.back();
      if (b.hasAttribute('data-fs-cta')) return this.next();
      if (b.hasAttribute('data-fs-sub-toggle')) { st.sub = !st.sub; this.save(); this.render(); return; }
      if (b.hasAttribute('data-fs-again')) { this.fresh(true); this._seen = {}; this.go(); return; }
      if (b.hasAttribute('data-fs-open-cart')) { FS.openCart(); return; }
    }
    linked(b, f) {
      var bs = this.state.builds;
      for (var i = 0; i < bs.length; i++) if (bs[i].from === b.id && bs[i].f === f && bs[i].s === b.s) return i;
      return -1;
    }
    pickScent(key) {
      var self = this, b = this.cur(); if (!b) return;
      if (b.s !== key) { b.s = key; b.adds = {}; b.vk = null; this._fill = b.id; }
      this.save(); this.render();
      // Narrow screens: bring the stage into view so the fill plays where they can see it
      if (window.matchMedia('(max-width: 989px)').matches) {
        var stg = this.$('[data-fs-stage]'); if (stg) { var y = stg.getBoundingClientRect().top + window.scrollY - 70; if (window.scrollY > y) window.scrollTo({ top: y, behavior: reduceMotion ? 'auto' : 'smooth' }); }
      }
      clearTimeout(this._adv);
      this._adv = setTimeout(function () { if (self.state.view === 'scent' && self.cur() === b) self.go('extras'); }, reduceMotion ? 150 : 1100);
    }
    save() {
      try {
        var s = this.state;
        sessionStorage.setItem('fsSetup2', JSON.stringify({ view: s.view === 'done' ? 'lineup' : s.view, builds: s.builds, cur: s.cur, sub: s.sub, plan: s.plan, uid: s.uid, gid: s.gid, gifts: s.gifts || {} }));
      } catch (e) {}
    }
    restore() {
      var st = this.state, self = this, q = new URLSearchParams(location.search);
      try {
        var r = JSON.parse(sessionStorage.getItem('fsSetup2') || 'null');
        if (r && Array.isArray(r.builds)) {
          st.builds = r.builds.filter(function (b) { return b && self.F.indexOf(b.f) > -1 && self.avail[b.f]; }).map(function (b) {
            if (b.s && !self.baseLine(self.scentFor(b.s), b.f)) b.s = null;
            b.adds = b.adds || {}; return b;
          });
          st.uid = Math.max(r.uid || 1, st.builds.reduce(function (m, b) { return Math.max(m, b.id + 1); }, 1));
          st.cur = Math.min(r.cur || 0, Math.max(0, st.builds.length - 1));
          st.sub = typeof r.sub === 'boolean' ? r.sub : st.sub; st.plan = r.plan || null;
          st.view = r.view || 'lineup'; st.gifts = r.gifts || {}; if (r.gid) st.gid = r.gid;
        }
      } catch (e) {}
      var f = q.get('format'), sk = q.get('scent');
      if (f && this.F.indexOf(f) > -1 && this.avail[f]) {
        var key = sk ? this.norm(sk.replace(/-/g, ' ')) : null;
        if (key && !this.baseLine(this.scentFor(key), f)) key = null;
        var exists = st.builds.some(function (b) { return b.f === f && b.s === key; });
        if (!exists) { st.builds.push(this.newBuild(f, key)); st.cur = st.builds.length - 1; st.view = key ? 'extras' : 'scent'; }
      }
      if (!st.builds.length) st.view = 'lineup';
      if ((st.view === 'scent' || st.view === 'extras') && !this.cur()) st.view = 'lineup';
      if (st.view === 'extras' && !this.done(this.cur())) st.view = 'scent';
      if (st.view === 'garage' && !this.canGarage()) st.view = 'lineup';
    }
    say(msg, kind) { var m = this.$('[data-fs-msg]'); if (m) { m.textContent = msg || ''; m.className = 'fs-cfg__msg' + (kind ? ' is-' + kind : ''); } }

    /* ----- render ----- */
    render() {
      var st = this.state, self = this;
      this.dataset.view = st.view;
      this.$$('[data-fs-view]').forEach(function (v) { var on = v.dataset.fsView === st.view; v.hidden = !on; v.classList.toggle('is-active', on); });
      this.renderRail();
      if (st.view === 'lineup') this.renderLineup();
      if (st.view === 'scent') this.renderScents();
      if (st.view === 'extras') this.renderExtras();
      // plans
      var names = this.planNames(), sel = this.$('[data-fs-sub-select]');
      if (names.length && (!st.plan || names.indexOf(st.plan) < 0)) st.plan = names[0];
      if (sel) {
        var self0 = this, html = names.map(function (n) { return '<option value="' + escapeHtml(n) + '">' + escapeHtml(self0.planLabel(n)) + '</option>'; }).join('');
        if (sel.innerHTML !== html) sel.innerHTML = html;
        if (st.plan) sel.value = st.plan;
      }
      if (st.view === 'garage') this.renderGarage(names);
      this.renderStage();
      this.renderBar();
      this._flash = null;
    }
    kicker(b) {
      var st = this.state;
      return this.t.kickerScent.replace('[n]', String(st.builds.indexOf(b) + 1)).replace('[total]', String(st.builds.length)).replace('[format]', this.t[b.f] || '');
    }
    renderRail() {
      var st = this.state, t = this.t, self = this, rail = this.$('[data-fs-rail]'); if (!rail) return;
      var check = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
      var html = '<li><button type="button" class="fs-cfg__chip fs-cfg__chip--step' + (st.view === 'lineup' ? ' is-active' : '') + (st.builds.length ? ' is-done' : '') + '" data-fs-rail="lineup"' + (st.view === 'lineup' ? ' aria-current="step"' : '') + '>' +
        '<span class="fs-cfg__chip-n">01</span><span class="fs-cfg__chip-t">' + escapeHtml(t.lineup) + '</span><span class="fs-cfg__chip-s">' + escapeHtml(t.units.replace('[n]', st.builds.length)) + '</span></button></li>';
      st.builds.forEach(function (b, i) {
        var s = self.scentFor(b.s), ok = self.done(b), line = ok ? self.lineOf(b) : null;
        var on = (st.view === 'scent' || st.view === 'extras') && st.cur === i;
        var img = line && line.img ? line.img : self.baseImg(b.f).src;
        html += '<li class="fs-cfg__rail-build' + (self._flash === b.id ? ' is-flash' : '') + '"><button type="button" class="fs-cfg__chip' + (on ? ' is-active' : '') + (ok ? ' is-done' : '') + '" data-fs-open="' + i + '"' + (on ? ' aria-current="step"' : '') + '>' +
          '<span class="fs-cfg__chip-img' + (ok ? '' : ' is-empty') + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="80" height="100">' : '') + (ok ? '<i class="fs-cfg__chip-ok">' + check + '</i>' : '') + '</span>' +
          '<span class="fs-cfg__chip-copy"><span class="fs-cfg__chip-n">' + (i < 8 ? '0' : '') + (i + 2) + ' \u00b7 ' + escapeHtml(t[b.f]) + '</span><span class="fs-cfg__chip-t">' + escapeHtml(s && ok ? s.name : t.pickScentShort) + '</span></span></button>' +
          '<button type="button" class="fs-cfg__chip-x" data-fs-remove="' + i + '" aria-label="' + escapeHtml(t.remove + ' ' + t[b.f] + ' ' + (i + 1)) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M7 7l10 10M17 7L7 17"/></svg></button></li>';
      });
      if (st.builds.length) {
        html += '<li class="fs-cfg__rail-add"><button type="button" class="fs-cfg__chip fs-cfg__chip--add" data-fs-add-menu aria-expanded="false"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg><span>' + escapeHtml(t.addBuild) + '</span></button><span class="fs-cfg__rail-menu">' +
          this.F.filter(function (f) { return self.avail[f]; }).map(function (f) { return '<button type="button" data-fs-new="' + f + '">' + escapeHtml(t[f]) + '</button>'; }).join('') + '</span></li>';
      }
      var g = this.canGarage();
      html += '<li><button type="button" class="fs-cfg__chip fs-cfg__chip--step fs-cfg__chip--garage' + (st.view === 'garage' || st.view === 'done' ? ' is-active' : '') + '" data-fs-rail="garage"' + (g ? '' : ' disabled') + '>' +
        '<span class="fs-cfg__chip-n">' + (st.builds.length + 2 < 10 ? '0' : '') + (st.builds.length + 2) + '</span><span class="fs-cfg__chip-t">' + escapeHtml(t.garage) + '</span></button></li>';
      rail.innerHTML = html;
      var act = rail.querySelector('.is-active');
      if (act && rail.scrollWidth > rail.clientWidth) {
        var r = act.getBoundingClientRect(), rr = rail.getBoundingClientRect();
        if (r.left < rr.left || r.right > rr.right) rail.scrollTo({ left: rail.scrollLeft + r.left - rr.left - 24, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }
    renderLineup() {
      var self = this, t = this.t;
      this.F.forEach(function (f) {
        var n = self.count(f), o = self.querySelector('[data-fs-qty-out="' + f + '"]'), card = self.querySelector('[data-fs-format="' + f + '"]');
        if (o) o.textContent = n;
        if (card) {
          card.classList.toggle('is-on', n > 0);
          var minus = card.querySelector('[data-fs-d="-1"]'); if (minus) minus.disabled = n === 0;
          card.querySelectorAll('[data-fs-d="1"]').forEach(function (x) { x.disabled = n >= self.max; });
        }
      });
      var hint = this.$('[data-fs-lineup-hint]'); if (hint) hint.textContent = t.lineupHint;
      var lad = this.$('[data-fs-ladder]');
      if (lad) {
        lad.hidden = !this.cfg.pack || !this.tiers.length;
        if (!lad.hidden) {
          var n = (this.cartUnits || 0) + this.state.builds.length, cur = null, next = null;
          this.tiers.forEach(function (x) { if (x.q <= n) cur = x; else if (!next) next = x; });
          lad.innerHTML = this.ladderHtml({ n: n, cur: cur, next: next, save: 0 }, false);
        }
      }
    }
    renderScents() {
      var st = this.state, t = this.t, self = this, b = this.cur(), box = this.$('[data-fs-scents]'); if (!box || !b) return;
      var k = this.$('[data-fs-kicker="scent"]'); if (k) k.textContent = this.kicker(b);
      this.$$('[data-fs-fam]').forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.fsFam === st.fam)); });
      var used = {}; st.builds.forEach(function (x) { if (x !== b && x.s) used[x.s] = (used[x.s] || 0) + 1; });
      var list = this.catalog.filter(function (s) { return self.hasLine(s, b.f) && (st.fam === 'all' || s.fam === st.fam); });
      list = list.filter(function (s) { return self.baseLine(s, b.f); }).concat(list.filter(function (s) { return !self.baseLine(s, b.f); }));
      var sig = b.id + '|' + b.f + '|' + st.fam + '|' + b.s + '|' + JSON.stringify(used);
      if (this._scentSig === sig) return; this._scentSig = sig;
      if (!list.length) { box.innerHTML = '<p class="fs-cfg__empty">' + escapeHtml(t.noScents) + '</p>'; return; }
      var tick = '<span class="fs-cfg__tick" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span>';
      box.innerHTML = list.map(function (s) {
        var base = self.baseLine(s, b.f), on = s.key === b.s, img = s.img || (base && base.img) || '';
        var notes = s.notes ? s.notes : (s.insp ? (/^inspired/i.test(s.insp) ? s.insp : t.inspired + ' ' + s.insp) : '');
        if (!base) {
          // sold out / between drops: stays visible, but locked
          var link = self.cfg.dropLink || s.url || '';
          return '<div class="fs-cfg__scent is-locked' + (s.img ? '' : ' is-photo') + '">' +
            '<span class="fs-cfg__scent-media">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="300" height="375">' : '') + '</span>' +
            '<span class="fs-cfg__scent-lock"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="1.5"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>' + escapeHtml(s.drop ? t.dropLocked : t.soldOut) + '</span>' +
            '<span class="fs-cfg__scent-body"><span class="fs-cfg__scent-name">' + escapeHtml(s.name) + '</span>' +
            (s.drop && self.cfg.dropDate ? '<span class="fs-cfg__scent-notes">' + escapeHtml(t.nextDrop.replace('[date]', self.cfg.dropDate)) + '</span>' : '') +
            (link ? '<a class="fs-cfg__scent-notify" href="' + escapeHtml(link) + '">' + escapeHtml(t.dropCta) + ' →</a>' : '') + '</span></div>';
        }
        return '<button type="button" class="fs-cfg__scent' + (on ? ' is-on' : '') + (s.img ? '' : ' is-photo') + (s.drop ? ' is-drop' : '') + '" role="radio" aria-checked="' + on + '" data-fs-scent="' + s.key + '">' +
          '<span class="fs-cfg__scent-media">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="300" height="375">' : '') + '</span>' +
          (used[s.key] ? '<span class="fs-cfg__scent-used" aria-hidden="true">×' + used[s.key] + '</span>' : '') +
          (s.drop ? '<span class="fs-cfg__scent-drop">' + escapeHtml(t.dropBadge) + '</span>' : '') +
          '<span class="fs-cfg__scent-body"><span class="fs-cfg__scent-name">' + escapeHtml(s.name) + '</span>' +
          (notes ? '<span class="fs-cfg__scent-notes">' + escapeHtml(notes) + '</span>' : '') +
          '<span class="fs-cfg__scent-price">' + FS.money(base.p) + '</span></span>' + tick + '</button>';
      }).join('');
    }
    stepper(key, q, max, label) {
      return '<span class="fs-cfg__stepper fs-cfg__stepper--sm" role="group" aria-label="' + escapeHtml(label) + '">' +
        '<button type="button" data-fs-add="' + key + '" data-fs-d="-1"' + (q <= 0 ? ' disabled' : '') + ' aria-label="−"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 12h12"/></svg></button>' +
        '<output>' + q + '</output>' +
        '<button type="button" data-fs-add="' + key + '" data-fs-d="1"' + (q >= max ? ' disabled' : '') + ' aria-label="+"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 6v12M6 12h12"/></svg></button></span>';
    }
    renderExtras() {
      var st = this.state, t = this.t, self = this, b = this.cur(); if (!b) return;
      var s = this.scentFor(b.s), base = this.lineOf(b); if (!base) return;
      var k = this.$('[data-fs-kicker="extras"]'); if (k) k.textContent = this.kicker(b);
      var defs = this.addonDefs(b), box = this.$('[data-fs-addons]');
      var check = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
      var fin = this.finishes(b);
      var finHtml = fin.length > 1 ? '<div class="fs-cfg__finish"><p class="fs-cfg__label">' + escapeHtml(t.finish) + '</p><div class="fs-cfg__finish-list">' + fin.map(function (x) {
        var on = x.key === base.key;
        return '<button type="button" class="fs-cfg__finish-btn' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-fs-var="' + escapeHtml(x.key) + '">' + (x.img ? '<img src="' + x.img + '" alt="" loading="lazy">' : '') + '<span>' + escapeHtml(x.n) + '</span></button>';
      }).join('') + '</div></div>' : '';
      if (box) box.innerHTML = finHtml + '<div class="fs-cfg__addon is-base"><span class="fs-cfg__addon-img">' + (base.img ? '<img src="' + base.img + '" alt="" loading="lazy">' : '') + '</span><span class="fs-cfg__addon-copy"><b>' + escapeHtml(t[b.f] + ' \u00b7 ' + s.name + (base.key && fin.length > 1 ? ' \u00b7 ' + base.n : '')) + '</b><small>' + escapeHtml(b.f === 'spray' ? t.sprays : t.upTo.replace('[n]', this.cfg.weeks[b.f])) + '</small></span><span class="fs-cfg__addon-price">' + FS.money(base.p) + '</span><span class="fs-cfg__addon-ok" aria-hidden="true">' + check + '</span></div>' +
        defs.map(function (a) {
          var q = b.adds[a.key] || 0;
          return '<div class="fs-cfg__addon' + (q ? ' is-on' : '') + '"><span class="fs-cfg__addon-img">' + (a.line.img ? '<img src="' + a.line.img + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="fs-cfg__addon-copy"><b>' + escapeHtml(a.title) + '</b><small>' + escapeHtml(a.text) + (a.weeks ? ' · +' + a.weeks + ' ' + escapeHtml(t.weeks) : '') + '</small></span>' +
            '<span class="fs-cfg__addon-price">' + FS.money(a.line.p) + '</span>' + self.stepper(a.key, q, self.maxAdd, a.title) + '</div>';
        }).join('');
      // timeline
      var tl = this.$('[data-fs-timeline]'), w = this.weeks(b);
      if (tl) {
        tl.hidden = b.f === 'spray' && !w.segs.length;
        var lap = this.$('[data-fs-lap]'), max = Math.max(w.total, this.cfg.weeks.diffuser + this.cfg.weeks.refill), acc = 0;
        if (lap) lap.innerHTML = w.segs.map(function (sg, i) {
          var left = acc / max * 100, width = sg.n / max * 100; acc += sg.n;
          return '<div class="fs-cfg__seg" style="--l:' + left.toFixed(2) + '%;--w:' + width.toFixed(2) + '%;--i:' + i + '"><span class="fs-cfg__seg-label">' + escapeHtml(sg.label) + '</span><span class="fs-cfg__seg-bar"><i></i></span><span class="fs-cfg__seg-n">' + acc + ' ' + escapeHtml(t.weeks) + '</span></div>';
        }).join('');
        var wk = this.$('[data-fs-weeks]'); if (wk) wk.textContent = w.total ? t.upTo.replace('[n]', w.total) : '—';
      }
      // same scent, other formats
      var cross = this.$('[data-fs-cross]'), wrap = this.$('[data-fs-cross-wrap]');
      var others = this.F.filter(function (f) { return f !== b.f && self.baseLine(s, f); });
      if (wrap) wrap.hidden = !others.length;
      if (cross) cross.innerHTML = others.map(function (f) { return self.crossBtn(f, s, 'data-fs-cross="' + f + '"', self.linked(b, f) > -1); }).join('');
    }
    crossBtn(f, s, attr, on) {
      var t = this.t, l = this.baseLine(s, f), img = l.img || this.baseImg(f).src;
      return '<button type="button" class="fs-cfg__cross-btn' + (on ? ' is-on' : '') + '" ' + attr + ' aria-pressed="' + !!on + '">' +
        '<span class="fs-cfg__cross-img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="fs-cfg__cross-copy"><b>' + escapeHtml(on ? t.inGarage : t.crossAdd.replace('[format]', (t[f] || '').toLowerCase())) + '</b><small>' + escapeHtml(s.name) + ' \u00b7 ' + FS.money(l.p) + '</small></span>' +
        '<span class="fs-cfg__cross-state" aria-hidden="true"><svg class="i-plus" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg><svg class="i-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span></button>';
    }
    renderGarage(names) {
      var st = this.state, t = this.t, self = this;
      // build lines
      var box = this.$('[data-fs-lines]');
      if (box) box.innerHTML = st.builds.map(function (b, i) {
        var s = self.scentFor(b.s), ok = self.done(b);
        if (!ok) return '<div class="fs-cfg__gline is-open"><span class="fs-cfg__gline-img is-empty">' + (self.baseImg(b.f).src ? '<img src="' + self.baseImg(b.f).src + '" alt="" loading="lazy">' : '') + '</span><span class="fs-cfg__gline-copy"><b>' + escapeHtml(t[b.f]) + '</b><small>' + escapeHtml(t.unfinished) + '</small></span>' +
          '<span class="fs-cfg__gline-acts"><button type="button" class="fs-cfg__link" data-fs-open="' + i + '">' + escapeHtml(t.pickScentShort) + '</button><button type="button" class="fs-cfg__link" data-fs-remove="' + i + '">' + escapeHtml(t.remove) + '</button></span></div>';
        var ls = self.buildLines(b), price = self.buildPrice(b), reg = ls.reduce(function (x, l) { return x + l.line.p * l.q; }, 0);
        var extras = ls.slice(1).map(function (l) { return l.label + (l.q > 1 ? ' ×' + l.q : ''); });
        var plan = self.planFor(ls[0].line), subTxt = st.sub ? (plan ? (self.planEvery(plan) || plan.n) : t.oneTime) : '';
        return '<div class="fs-cfg__gline' + (self._flash === b.id ? ' is-flash' : '') + '"><span class="fs-cfg__gline-img">' + (ls[0].line.img ? '<img src="' + ls[0].line.img + '" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="fs-cfg__gline-copy"><b>' + escapeHtml(t[b.f] + ' \u00b7 ' + s.name) + '</b><small>' + escapeHtml(extras.length ? t.with + ' ' + extras.join(', ') : t.none) + (subTxt ? ' · ' + escapeHtml(subTxt) : '') + '</small>' +
          '<span class="fs-cfg__gline-acts"><button type="button" class="fs-cfg__link" data-fs-open="' + i + '">' + escapeHtml(t.edit) + '</button><button type="button" class="fs-cfg__link" data-fs-remove="' + i + '">' + escapeHtml(t.remove) + '</button></span></span>' +
          '<span class="fs-cfg__gline-price">' + (price < reg ? '<s>' + FS.money(reg) + '</s>' : '') + '<b>' + FS.money(price) + '</b></span></div>';
      }).join('');
      var gsub = this.$('[data-fs-g-sub]');
      if (gsub) { if (!gsub.dataset.def) gsub.dataset.def = gsub.textContent; gsub.textContent = st.builds.some(function (b) { return !self.done(b); }) ? t.unfinished : gsub.dataset.def; }
      // bundle discount
      var pk = this.pack(), pbox = this.$('[data-fs-pack]');
      if (pbox) {
        pbox.hidden = !pk;
        if (pk) pbox.innerHTML = this.ladderHtml(pk, true);
      }
      this.renderGifts();
      // build another
      var an = this.$('[data-fs-another]');
      if (an) an.innerHTML = this.F.filter(function (f) { return self.avail[f]; }).map(function (f) {
        var bi = self.baseImg(f);
        return '<button type="button" class="fs-cfg__another-btn" data-fs-new="' + f + '"><span class="fs-cfg__another-img' + (bi.ghost ? ' is-ghost' : '') + '">' + (bi.src ? '<img src="' + bi.src + '" alt="" loading="lazy">' : '') + '</span><span>+ ' + escapeHtml(t[f]) + '</span></button>';
      }).join('');
      // complete the set
      var have = {}, scents = [];
      st.builds.forEach(function (b) { if (!self.done(b)) return; if (!have[b.s]) { have[b.s] = {}; scents.push(b.s); } have[b.s][b.f] = 1; });
      var chips = [];
      scents.forEach(function (k) { var s = self.scentFor(k); self.F.forEach(function (f) { if (!have[k][f] && self.baseLine(s, f) && self.count(f) < self.max) chips.push(self.crossBtn(f, s, 'data-fs-complete="' + f + '|' + k + '"', false)); }); });
      var cw = this.$('[data-fs-complete-wrap]'), cl = this.$('[data-fs-complete]');
      if (cw) cw.hidden = !chips.length;
      if (cl) cl.innerHTML = chips.slice(0, 4).join('');
      // subscription
      var subbox = this.$('[data-fs-subbox]');
      if (subbox) {
        subbox.hidden = !names.length;
        var tog = this.$('[data-fs-sub-toggle]'); if (tog) tog.setAttribute('aria-checked', String(st.sub));
        subbox.classList.toggle('is-on', st.sub);
        var pw = this.$('[data-fs-sub-plan]'); if (pw) pw.hidden = !(st.sub && names.length > 1);
        var lines = this.allLines(), save = 0, was = st.sub, det = [];
        st.sub = true;
        lines.forEach(function (l) {
          var p = self.planFor(l.line); if (!p) return;
          save += (l.line.p - p.p) * l.q;
          var bits = [];
          if (p.o) bits.push(self.planEvery(p));
          if (p.adj && p.adj.length > 1 && p.adj[p.adj.length - 1] !== p.adj[0]) bits.push(t.then.replace('[first]', FS.money(p.adj[0])).replace('[later]', FS.money(p.adj[p.adj.length - 1])));
          if (p.d) bits.push(p.d);
          var name = l.label + ' \u00b7 ' + self.scentFor(l.b.s).name;
          if (bits.length && det.indexOf(name) < 0) det.push('<p><b>' + escapeHtml(name) + '</b> — ' + bits.map(escapeHtml).join(' · ') + '</p>');
        });
        st.sub = was;
        var badge = this.$('[data-fs-sub-badge]'); if (badge) { badge.hidden = save <= 0; badge.textContent = t.subBadge.replace('[amount]', FS.money(save)); }
        var dbox = this.$('[data-fs-sub-detail]'); if (dbox) { dbox.innerHTML = st.sub ? det.join('') : ''; dbox.hidden = !(st.sub && det.length); }
      }
    }

    plural(str, n) { return str.replace('[n]', n).replace('[s]', n === 1 ? '' : 's'); }
    ladderHtml(pk, full) {
      var t = this.t, self = this, top = this.tiers[this.tiers.length - 1].q;
      var nextN = pk.next ? pk.next.q - pk.n : 0;
      var head = pk.cur ? t.packNow.replace('[pct]', pk.cur.pct) : this.plural(t.packStart, nextN).replace('[pct]', pk.next.pct);
      var sub = pk.cur ? (pk.next ? this.plural(t.packNext, nextN).replace('[pct]', pk.next.pct) : t.packMax) : '';
      var tag = pk.cur && pk.cur.name ? '<i class="fs-cfg__pack-tag">' + escapeHtml(pk.cur.name) + '</i>' : '';
      return '<div class="fs-cfg__pack-top"><div class="fs-cfg__pack-msg"><span class="fs-cfg__pack-kicker">' + escapeHtml(t.packTitle) + '</span>' +
          '<b>' + escapeHtml(head) + tag + '</b>' + (sub ? '<span' + (pk.next ? '' : ' class="is-max"') + '>' + escapeHtml(sub) + '</span>' : '') + '</div>' +
          (full && pk.next && this.avail.diffuser ? '<button type="button" class="fs-btn fs-btn--sm" data-fs-new="diffuser">' + escapeHtml(t.packAdd) + '</button>' : '') + '</div>' +
        '<div class="fs-cfg__pack-track" style="--p:' + Math.min(1, pk.n / top).toFixed(3) + '"><i></i>' +
        this.tiers.map(function (x, i) {
          var last = i === self.tiers.length - 1;
          return '<span class="fs-cfg__pack-tick' + (pk.n >= x.q ? ' is-hit' : '') + '" style="--x:' + (x.q / top).toFixed(3) + '"><b>' + x.q + (last ? '+' : '') + '</b><small>' + escapeHtml(self.plural(t.packItems, x.q).replace(x.q + ' ', x.q + (last ? '+ ' : ' '))) + '<em>−' + x.pct + '%</em></small></span>';
        }).join('') + '</div>' +
        (full ? '<p class="fs-cfg__fine">' + escapeHtml(t.packNote) + (pk.save ? ' · ' + escapeHtml(t.packSave) + ' ≈ ' + FS.money(pk.save) : '') + '</p>' : '');
    }
    renderGifts() {
      var self = this, t = this.t, st = this.state, box = this.$('[data-fs-gifts]');
      if (!box) return;
      box.hidden = !this.gifts.length;
      if (!this.gifts.length) return;
      st.gifts = st.gifts || {};
      var gs = this.giftState(), top = gs.top || 1;
      var head = gs.next ? t.giftNext.replace('[amount]', FS.money(gs.next.amount - gs.value)).replace('[gift]', gs.next.label) : t.giftAll;
      var html = '<div class="fs-cfg__gifts-top"><p class="fs-cfg__label">' + escapeHtml(t.giftTitle) + '</p><p class="fs-cfg__gifts-msg">' + escapeHtml(head) + '</p></div>' +
        '<div class="fs-cfg__pack-track fs-cfg__gift-track" style="--p:' + Math.min(1, gs.value / top).toFixed(3) + '"><i></i>' +
        this.gifts.map(function (g) {
          return '<span class="fs-cfg__pack-tick' + (gs.value >= g.amount ? ' is-hit' : '') + '" style="--x:' + (g.amount / top).toFixed(3) + '"><b><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 21V7M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 1 0 0-5C13 2 12 7 12 7z"/></svg></b><small>' + escapeHtml(FS.money(g.amount).replace(/\.00$/, '')) + '</small></span>';
        }).join('') + '</div>';
      html += gs.got.filter(function (g) { return g.variants && g.variants.length > 1; }).map(function (g) {
        var pick = st.gifts[g.key] || 'mystery';
        var opts = g.variants.filter(function (v) { return v.a !== false; }).map(function (v) {
          var k = self.norm(v.n); return '<option value="' + escapeHtml(k) + '"' + (k === pick ? ' selected' : '') + '>' + escapeHtml(/^mystery$/i.test(v.n) ? t.giftMystery : v.n) + '</option>';
        }).join('');
        var mine = {}; st.builds.forEach(function (b) { if (self.done(b) && self.giftVariant(g, b.s)) mine[b.s] = 1; });
        var quick = Object.keys(mine).slice(0, 4).map(function (k) { var sc = self.scentFor(k); return '<button type="button" class="fs-chip' + (pick === k ? ' is-on' : '') + '" aria-pressed="' + (pick === k) + '" data-fs-gift="' + g.key + '|' + k + '">' + escapeHtml(sc ? sc.name : k) + '</button>'; }).join('');
        var sc = pick !== 'mystery' ? self.scentFor(pick) : null;
        return '<div class="fs-cfg__gift">' +
          '<span class="fs-cfg__gift-img">' + (sc && sc.img ? '<img src="' + sc.img + '" alt="" loading="lazy">' : g.img ? '<img src="' + g.img + '" alt="" loading="lazy">' : '') + '<i>' + escapeHtml(t.free) + '</i></span>' +
          '<span class="fs-cfg__gift-body"><b>' + escapeHtml(t.giftUnlocked.replace('[gift]', g.label)) + '</b>' +
          '<label class="fs-cfg__gift-pick"><span>' + escapeHtml(t.giftPick) + '</span><span class="fs-select"><select data-fs-gift-select="' + g.key + '">' + opts + '</select></span></label>' +
          (quick ? '<span class="fs-cfg__gift-quick">' + quick + '</span>' : '') + '</span></div>';
      }).join('');
      html += '<p class="fs-cfg__fine">' + escapeHtml(t.giftNote) + '</p>';
      box.innerHTML = html;
    }

    /* ----- stage ----- */
    renderStage() {
      var st = this.state, inner = this.stage; if (!inner) return;
      var mode = st.view === 'scent' || st.view === 'extras' ? 'build' : st.view === 'lineup' ? 'lineup' : 'garage';
      if (mode === 'build') return this.stageBuild(this.cur());
      this._stageKey = null;
      if (mode === 'lineup') return this.stageLineup();
      return this.stageGarage();
    }
    stageLineup() {
      var self = this, t = this.t, st = this.state, inner = this.stage;
      if (!st.builds.length) {
        inner.innerHTML = '<div class="fs-stage__show is-empty">' + this.F.filter(function (f) { return self.avail[f]; }).map(function (f, i) {
          var bi = self.baseImg(f);
          return '<figure class="fs-stage__ghost" style="--i:' + i + '">' + (bi.src ? '<img src="' + bi.src + '" alt=""' + (bi.ghost ? ' class="is-ghost"' : '') + '>' : '') + '<figcaption>' + escapeHtml(t[f]) + '</figcaption></figure>';
        }).join('') + '<p class="fs-stage__empty">' + escapeHtml(t.emptyStage) + '</p></div>';
        return;
      }
      var cards = st.builds.map(function (b, i) { return { b: b, idx: i, n: 1 }; });
      if (st.builds.length > 6) return this.stageRows(cards, false);
      var n = st.builds.length, cls = n > 3 ? ' is-sm' : '';
      inner.innerHTML = '<div class="fs-stage__show' + cls + '">' + cards.map(function (c, i) { return self.slot(c, i, false); }).join('') + '</div>';
    }
    slot(c, i, link, short) {
      var t = this.t, b = c.b, s = this.scentFor(b.s), line = this.done(b) ? this.lineOf(b) : null, bi = this.baseImg(b.f);
      var isNew = !this._seen[b.id] || this._flash === b.id; this._seen[b.id] = 1;
      var ex = line ? this.buildLines(b).slice(1).reduce(function (x, l) { return x + l.q; }, 0) : 0;
      var tag = link ? 'button type="button" data-fs-open="' + c.idx + '"' : 'figure';
      return '<' + tag + ' class="fs-stage__slot' + (isNew ? ' is-new' : '') + (line ? ' is-filled' : '') + '" style="--i:' + i + '">' +
        (line && s.img ? '<img class="fs-stage__slot-splash" src="' + s.img + '" alt="">' : '') +
        '<span class="fs-stage__slot-plate">' + (line && line.img ? '<img src="' + line.img + '" alt="">' : bi.src ? '<img src="' + bi.src + '" alt=""' + (bi.ghost ? ' class="is-ghost"' : '') + '>' : '') +
        (c.n > 1 ? '<span class="fs-stage__slot-qty">×' + c.n + '</span>' : '') + (ex ? '<span class="fs-stage__slot-ex">+' + ex + '</span>' : '') + '</span>' +
        '<span class="fs-stage__slot-cap"><b>' + escapeHtml(line ? (short ? s.name.replace(/^formula\s+/i, '') : s.name) : t[b.f]) + '</b><small>' + escapeHtml(line ? t[b.f] : t.pickScentShort) + '</small></span>' +
        '</' + (link ? 'button' : 'figure') + '>';
    }
    stageRows(cards, link) {
      var self = this, t = this.t, rows = [];
      this.F.forEach(function (f) {
        var list = cards.filter(function (c) { return c.b.f === f; });
        if (list.length) rows.push({ f: f, list: list, units: list.reduce(function (x, c) { return x + c.n; }, 0) });
      });
      var cols = Math.max(4, rows.reduce(function (m, r) { return Math.max(m, r.list.length); }, 0));
      var k = 0;
      this.stage.innerHTML = '<div class="fs-stage__rows" style="--cols:' + cols + ';--rows:' + rows.length + '">' + rows.map(function (r) {
        return '<div class="fs-stage__row"><p class="fs-stage__row-label"><b>' + escapeHtml(t[r.f]) + '</b><span>×' + r.units + '</span></p>' +
          '<div class="fs-stage__row-cards">' + r.list.map(function (c) { return self.slot(c, k++, link, true); }).join('') + '</div></div>';
      }).join('') + '</div>';
    }
    stageGarage() {
      var self = this, st = this.state, inner = this.stage, cards = [], byKey = {};
      st.builds.forEach(function (b, i) {
        if (!self.done(b)) return;
        // identical builds (same format, scent and extras) stack into one card with a ×N badge
        var key = b.f + '|' + b.s + '|' + JSON.stringify(b.adds || {});
        if (byKey[key]) { byKey[key].n++; if (self._flash === b.id) byKey[key].b = b; return; }
        byKey[key] = { b: b, idx: i, n: 1 }; cards.push(byKey[key]);
      });
      var units = cards.reduce(function (x, c) { return x + c.n; }, 0);
      if (cards.length > 6 || units > 6) return this.stageRows(cards, true);
      var n = cards.length, cls = n > 3 ? ' is-sm' : '';
      inner.innerHTML = '<div class="fs-stage__show fs-stage__show--garage' + cls + '">' + cards.map(function (c, i) { return self.slot(c, i, true); }).join('') + '</div>';
    }
    stageBuild(b) {
      var inner = this.stage, t = this.t, self = this; if (!b) return;
      var s = this.scentFor(b.s), line = this.done(b) ? this.lineOf(b) : null, bi = this.baseImg(b.f);
      var key = 'b' + b.id + b.f;
      if (this._stageKey !== key) {
        var prev = this._stageKey; this._stageKey = key; this._stageScent = null;
        inner.innerHTML = '<div class="fs-stage__build' + (prev ? ' is-enter' : '') + '">' +
          '<div class="fs-stage__splash"><img data-sp="a" alt=""><img data-sp="b" alt=""></div>' +
          '<div class="fs-stage__hud"><span data-hud-n></span><span data-hud-f></span></div>' +
          '<figure class="fs-stage__unit"><span class="fs-stage__plate">' +
            (bi.src ? '<img class="fs-stage__base' + (bi.ghost ? ' is-ghost' : '') + '" src="' + bi.src + '" alt="">' : '') +
            '<img class="fs-stage__fill" alt="" data-fill><i class="fs-stage__scan" aria-hidden="true"></i></span></figure>' +
          '<div class="fs-stage__extras" data-ex></div>' +
          '<div class="fs-stage__spec"><p class="fs-stage__name" data-name></p><p class="fs-stage__insp" data-insp></p>' +
          '<dl class="fs-stage__dl"><div><dt>' + escapeHtml(t.runTime) + '</dt><dd data-run></dd></div><div><dt>' + escapeHtml(t.price) + '</dt><dd data-price></dd></div></dl></div></div>';
      }
      var root = inner.firstElementChild;
      var q = function (sel) { return root.querySelector(sel); };
      q('[data-hud-n]').textContent = t.build + ' ' + (this.state.builds.indexOf(b) < 9 ? '0' : '') + (this.state.builds.indexOf(b) + 1) + ' / ' + (this.state.builds.length < 10 ? '0' : '') + this.state.builds.length;
      q('[data-hud-f]').textContent = t[b.f];
      q('[data-name]').textContent = s && line ? s.name : t.pickScentShort;
      q('[data-insp]').textContent = s && line ? (s.notes || (s.insp ? (/^inspired/i.test(s.insp) ? s.insp : t.inspired + ' ' + s.insp) : '')) : (t[b.f] || '');
      var w = this.weeks(b);
      q('[data-run]').textContent = line ? (b.f === 'spray' && !w.total ? t.sprays : t.upTo.replace('[n]', w.total)) : '—';
      q('[data-price]').textContent = line ? FS.money(this.buildPrice(b)) : '—';
      // extras badges
      var ex = q('[data-ex]');
      if (ex) ex.innerHTML = line ? this.buildLines(b).slice(1).map(function (l) { return '<span class="fs-stage__chip">' + (l.line.img ? '<img src="' + l.line.img + '" alt="">' : '') + '<b>' + escapeHtml(l.label) + '</b>' + (l.q > 1 ? '<i>×' + l.q + '</i>' : '') + '</span>'; }).join('') : '';
      // scent fill
      var sk = line ? b.s + '|' + (line.key || '') : null;
      if (sk === this._stageScent) return;
      this._stageScent = sk;
      var fill = q('[data-fill]'), build = root, animate = this._fill === b.id;
      this._fill = null;
      // splash crossfade
      var a = q('[data-sp="a"]'), bb = q('[data-sp="b"]'), showA = !a.classList.contains('is-on');
      var into = showA ? a : bb, out = showA ? bb : a;
      if (s && line && s.img) { into.src = s.img; into.classList.add('is-on'); } else { into.removeAttribute('src'); into.classList.remove('is-on'); }
      out.classList.remove('is-on');
      build.classList.toggle('has-scent', !!line);
      if (!line) { build.classList.remove('is-filled', 'is-filling'); fill.removeAttribute('src'); return; }
      var reveal = function () {
        if (!animate || reduceMotion) { build.classList.add('is-filled'); return; }
        build.classList.remove('is-filled', 'is-filling'); void build.offsetWidth;
        build.classList.add('is-filling');
        requestAnimationFrame(function () { build.classList.add('is-filled'); });
      };
      build.classList.remove('is-filled');
      if (line.img) {
        var done = false, go = function () { if (done) return; done = true; reveal(); };
        fill.onload = go; fill.src = line.img;
        if (fill.complete) go(); else setTimeout(go, 1200);
      } else reveal();
    }

    /* ----- bar ----- */
    renderBar() {
      var st = this.state, t = this.t, self = this;
      var lines = this.allLines();
      var reg = lines.reduce(function (x, l) { return x + l.line.p * l.q; }, 0);
      var pk = this.pack();
      var tot = Math.max(0, lines.reduce(function (x, l) { return x + self.unit(l) * l.q; }, 0) - (pk ? pk.save : 0));
      var set = function (sel, v) { var e = self.$(sel); if (e) e.textContent = v; };
      set('[data-fs-total]', FS.money(tot));
      var was = this.$('[data-fs-was]'); if (was) { was.hidden = !(tot < reg); was.textContent = FS.money(reg); }
      set('[data-fs-sum-label]', st.view === 'lineup' ? t.units.replace('[n]', st.builds.length) : (pk && pk.cur ? t.packBadge.replace('[pct]', pk.cur.pct) : t.subtotal));
      var back = this.$('[data-fs-back]'); if (back) back.hidden = st.view === 'lineup' || st.view === 'done';
      var cta = this.$('[data-fs-cta]'), lbl = this.$('[data-fs-cta-label]');
      var label = '', ok = true, b = this.cur();
      if (st.view === 'lineup') { ok = st.builds.length > 0; label = ok ? t.start.replace('[n]', st.builds.length) : t.pick; }
      else if (st.view === 'scent') { ok = this.done(b); label = ok ? this.nextLabel() : t.pickScent; }
      else if (st.view === 'extras') { label = this.nextLabel(); }
      else if (st.view === 'garage') { var c = lines.reduce(function (x, l) { return x + l.q; }, 0); ok = c > 0; var addT = window.matchMedia('(max-width: 749px)').matches ? t.add.replace(/\s*[·\-–|]\s*\[total\]/, '') : t.add; label = addT.replace('[count]', c).replace('[total]', FS.money(tot)); }
      if (cta) { cta.disabled = !ok || !!this._busy; cta.hidden = st.view === 'done'; cta.classList.toggle('is-go', st.view === 'garage'); }
      if (lbl && !this._busy) lbl.textContent = label;
      this.classList.toggle('is-final', st.view === 'garage');
    }
    nextLabel() {
      var st = this.state, t = this.t;
      if (st.view === 'scent') return ((this.$('[data-fs-view="extras"] .fs-cfg__h') || {}).textContent || t.toGarage).trim();
      var nb = null;
      for (var i = st.cur + 1; i < st.builds.length; i++) if (!this.done(st.builds[i])) { nb = st.builds[i]; break; }
      if (!nb) { var o = this.firstOpen(); if (o > -1 && o !== st.cur) nb = st.builds[o]; }
      return nb ? t.nextBuild.replace('[format]', t[nb.f]).replace('[n]', this.count(nb.f) > 1 ? this.nOf(nb) : '').replace(/\s+$/, '') : t.toGarage;
    }
    cartChange(key, qty) {
      return fetch(this.cartRoot() + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); });
    }
    cartUpdate(body) {
      return fetch(this.cartRoot() + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
    }
    getCart() { return fetch(this.cartRoot() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
    // Vex owns the gift lines (it adds "Mystery" at the threshold and removes it below). The builder never
    // adds or removes gift lines; it labels the scent the shopper picked:
    //  1. as an order note attribute ("Free diffuser scent: Titanium") — always, so packers see it, and
    //  2. as a "Scent" property on Vex's gift line once that line exists (shown in the cart and on the order).
    applyGifts() {
      var self = this, picks = this.state.gifts || {};
      var gifts = this.gifts.filter(function (g) { return g.pid; });
      if (!gifts.length || !window.fetch) return Promise.resolve();
      var nameOf = function (g) { var k = picks[g.key]; var v = k && k !== 'mystery' ? self.giftVariant(g, k) : null; return v ? v.n : ''; };
      var attrKey = function (g) { return g.label.replace(/^./, function (c) { return c.toUpperCase(); }) + ' scent'; };
      var tries = 0;
      var run = function () {
        return self.getCart().then(function (c) {
          self.readCart(c);
          var attrs = {}, chain = Promise.resolve(), missing = false;
          gifts.forEach(function (g) {
            var pick = self.cartValue >= g.amount ? nameOf(g) : '';
            attrs[attrKey(g)] = pick;                       // empty string clears it
            if (!pick) return;
            var line = (c.items || []).filter(function (it) { return it.product_id === g.pid; })[0];
            if (!line) { missing = true; return; }
            var props = {}; Object.keys(line.properties || {}).forEach(function (k) { props[k] = line.properties[k]; });
            if (props.Scent === pick) return;
            props.Scent = pick;
            chain = chain.then(function () {
              return fetch(self.cartRoot() + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.key, quantity: line.quantity, properties: props }) });
            });
          });
          return chain.then(function () { return self.cartUpdate({ attributes: attrs }); }).then(function () {
            // Vex adds its line a moment after the cart changes; check back a few times
            if (missing && ++tries < 5) return new Promise(function (res) { setTimeout(res, 800); }).then(run);
          });
        });
      };
      return run().then(function () { return self.loadCart(); }).catch(function () {});
    }
    submit() {
      var self = this, st = this.state, prop = this.cfg.prop || 'Setup';
      var have = this.inCart || {};
      var all = this.allLines().map(function (l) {
        var it = { id: l.line.v, quantity: l.q, properties: {} };
        it.properties[prop] = self.t.build + ' ' + (l.i + 1) + ' \u00b7 ' + self.t[l.b.f] + ' \u00b7 ' + self.scentFor(l.b.s).name + (l.role === 'base' && l.line.key && self.finishes(l.b).length > 1 ? ' \u00b7 ' + l.line.n : '');
        it.properties._fs_g = st.gid + '-' + l.b.id + '-' + l.role;
        var p = self.planFor(l.line); if (p) it.selling_plan = p.id;
        return it;
      });
      if (!all.length) return;
      // anything this garage already added (e.g. a retry after an error) isn't added again
      var items = all.filter(function (it) { return !have[it.properties._fs_g]; });
      if (!items.length) { this.state.view = 'done'; var dt0 = this.$('[data-fs-done-text]'); if (dt0) dt0.textContent = this.t.doneText.replace('[count]', all.reduce(function (x, i) { return x + i.quantity; }, 0)); try { sessionStorage.removeItem('fsSetup2'); } catch (e) {} this.render(); return; }
      var count = items.reduce(function (x, i) { return x + i.quantity; }, 0);
      this._busy = true; var lbl = this.$('[data-fs-cta-label]'), cta = this.$('[data-fs-cta]');
      if (lbl) lbl.textContent = this.t.adding; if (cta) cta.disabled = true;
      FS.addToCart(items).then(function () { return self.applyGifts(); }).then(function () {
        self._busy = false;
        var dt = self.$('[data-fs-done-text]'); if (dt) dt.textContent = self.t.doneText.replace('[count]', count);
        self.state.view = 'done';
        self.state.gid = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
        try { sessionStorage.removeItem('fsSetup2'); } catch (e) {}
        self.render();
        if (self.cfg.openCart) FS.openCart();
      }).catch(function (err) { self._busy = false; self.say(err && err.message ? err.message : String(err), 'error'); self.render(); });
    }
  });

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  /* ---------- Scent finder ---------- */
  define('fs-quiz', class extends HTMLElement {
    connectedCallback() {
      var dataEl = this.querySelector('script[data-fs-quiz-data]');
      if (!dataEl) return;
      try { this.cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
      this.steps = Array.prototype.slice.call(this.querySelectorAll('[data-fs-q]'));
      this.answers = new Array(this.steps.length);
      this.i = 0;
      this.card = this.querySelector('.fs-quiz__card');
      this.result = this.querySelector('[data-fs-result]');
      this.questions = this.querySelector('[data-fs-questions]');
      this.addEventListener('click', this.onClick.bind(this));
      this.show();
    }
    onClick(e) {
      var b = e.target.closest('button, a[data-fs-quiz-pack]'); if (!b || !this.contains(b)) return;
      if (b.dataset.fsAnswer !== undefined) {
        this.answers[this.i] = Number(b.dataset.fsAnswer);
        var self = this;
        this.steps[this.i].querySelectorAll('[data-fs-answer]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        setTimeout(function () { self.next(); }, reduceMotion ? 0 : 260);
      } else if (b.hasAttribute('data-fs-back')) { if (this.i > 0) { this.i--; this.show(); } }
      else if (b.hasAttribute('data-fs-restart')) { this.answers = new Array(this.steps.length); this.i = 0; this.show(); }
      else if (b.hasAttribute('data-fs-quiz-pack')) { e.preventDefault(); this.toPack(); }
    }
    next() { if (this.i < this.steps.length - 1) { this.i++; this.show(); } else { this.finish(); } }
    show() {
      var self = this;
      this.result.hidden = true; this.questions.hidden = false;
      this.steps.forEach(function (s, k) { s.hidden = k !== self.i; });
      this.card.style.setProperty('--fs-q', (this.i / this.steps.length).toFixed(3));
      var back = this.querySelector('[data-fs-back]'); if (back) back.disabled = this.i === 0;
    }
    finish() {
      var scores = {}, cfg = this.cfg, self = this;
      this.steps.forEach(function (s, k) {
        var a = self.answers[k]; if (a === undefined) return;
        var ans = cfg.q[k] && cfg.q[k][a]; if (!ans) return;
        ans.forEach(function (ci) { scores[ci] = (scores[ci] || 0) + 1; });
      });
      var best = Object.keys(scores).sort(function (a, b) { return scores[b] - scores[a]; })[0];
      var col = cfg.c[best] || cfg.c[0];
      if (!col) return;
      this.pick = col;
      this.card.style.setProperty('--fs-q', 1);
      this.questions.hidden = true; this.result.hidden = false;
      this.result.querySelector('[data-fs-result-title]').textContent = col.title;
      this.result.querySelector('[data-fs-result-link]').setAttribute('href', col.url);
      var picks = col.p.slice(0, 3);
      this.result.querySelector('[data-fs-result-picks]').innerHTML = picks.map(function (p) {
        return '<a class="fs-quiz__pick" href="' + p.u + '"><span class="fs-quiz__pick-media">' + (p.img ? '<img src="' + p.img + '" alt="" loading="lazy" width="240" height="240">' : '') +
          '</span><span class="fs-quiz__pick-name">' + escapeHtml(p.t) + '</span><span class="fs-pcard__price">' + FS.money(p.p) + '</span></a>';
      }).join('');
    }
    toPack() {
      if (!this.pick) return;
      var vs = this.pick.p.filter(function (p) { return p.a; }).slice(0, 3).map(function (p) { return p.v; });
      var pack = document.querySelector('fs-pack');
      if (pack) {
        window.dispatchEvent(new CustomEvent('fs:pack:add', { detail: { variants: vs, size: 3 } }));
        pack.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      } else if (this.cfg.packUrl) {
        window.location.href = this.cfg.packUrl + (this.cfg.packUrl.indexOf('?') > -1 ? '&' : '?') + 'pack=' + vs.join(',');
      }
    }
  });

  /* ---------- Video reel ---------- */
  define('fs-reel', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.track = this.querySelector('[data-fs-reel-track]');
      this.vids = Array.prototype.slice.call(this.querySelectorAll('video'));
      if ('IntersectionObserver' in window && !reduceMotion) {
        this.io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var v = e.target;
            if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
            else v.pause();
          });
        }, { threshold: 0.4 });
        this.vids.forEach(function (v) { v.muted = true; self.io.observe(v); });
      }
      this.addEventListener('click', function (e) {
        var s = e.target.closest('[data-fs-sound]');
        if (s) {
          var clip = s.closest('.fs-clip'), v = clip.querySelector('video');
          var unmute = v.muted;
          self.vids.forEach(function (x) { x.muted = true; x.closest('.fs-clip').classList.remove('is-unmuted'); });
          v.muted = !unmute; clip.classList.toggle('is-unmuted', unmute);
          if (unmute) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          s.setAttribute('aria-pressed', String(unmute));
          return;
        }
        var nav = e.target.closest('[data-fs-reel-dir]');
        if (nav && self.track) {
          var card = self.track.firstElementChild;
          var step = card ? card.getBoundingClientRect().width + 16 : 300;
          self.track.scrollBy({ left: step * Number(nav.dataset.fsReelDir), behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      });
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
  });

  /* ---------- Drop countdown ---------- */
  define('fs-countdown', class extends HTMLElement {
    connectedCallback() {
      this.end = Date.parse(this.dataset.deadline);
      this.cells = {
        d: this.querySelector('[data-fs-d]'), h: this.querySelector('[data-fs-h]'),
        m: this.querySelector('[data-fs-m]'), s: this.querySelector('[data-fs-s]')
      };
      if (isNaN(this.end)) return;
      this.tick();
      this.timer = setInterval(this.tick.bind(this), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() {
      var left = Math.max(0, this.end - Date.now());
      var d = Math.floor(left / 864e5), h = Math.floor(left % 864e5 / 36e5), m = Math.floor(left % 36e5 / 6e4), s = Math.floor(left % 6e4 / 1e3);
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      if (this.cells.d) this.cells.d.textContent = pad(d);
      if (this.cells.h) this.cells.h.textContent = pad(h);
      if (this.cells.m) this.cells.m.textContent = pad(m);
      if (this.cells.s) this.cells.s.textContent = pad(s);
      if (left === 0) {
        clearInterval(this.timer);
        var section = this.closest('[data-fs-drop]');
        if (section) section.classList.add('is-live');
        this.querySelectorAll('[data-fs-when-live]').forEach(function (el) { el.hidden = false; });
        this.querySelectorAll('[data-fs-when-waiting]').forEach(function (el) { el.hidden = true; });
      }
    }
  });

  /* ---------- Boot ---------- */
  function boot() { initOverlay(); onScroll(); initReveal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); measureHeader(); });
})();
